// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
:root {
  --color-bg: #edf7ff;
  --color-surface: #ffffff;
  --color-border: #d9e5f2;
  --color-text: #1d2b3c;
  --color-text-muted: #68788e;
  --color-primary: #2379f4;
  --color-primary-hover: #1267dc;
  --color-primary-light: #e8f2ff;
  --color-success: #16833b;
  --color-success-bg: #e7f6eb;
  --color-error: #e43045;
  --color-error-bg: #fff0f2;
  --color-warning: #f1a62a;
  --radius: 6px;
  --radius-lg: 10px;
  --shadow: 0 8px 28px rgba(5, 40, 98, 0.08);
  --font: Inter, 'Segoe UI', Roboto, Arial, sans-serif;
}
html,
body,
#root {
  height: 100%;
}
body {
  font-family: var(--font);
  background: var(--color-bg);
  color: var(--color-text);
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}
/* ── Buttons ── */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.55rem 1.1rem;
  border: 1px solid transparent;
  border-radius: var(--radius);
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  font-family: inherit;
}
.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.btn-primary {
  background: var(--color-primary);
  color: #fff;
}
.btn-primary:hover:not(:disabled) {
  background: var(--color-primary-hover);
}
.btn-secondary {
  background: var(--color-surface);
  color: var(--color-text);
  border-color: var(--color-border);
}
.btn-secondary:hover:not(:disabled) {
  background: var(--color-bg);
}
.btn-ghost {
  background: transparent;
  color: var(--color-text-muted);
  border-color: var(--color-border);
}
.btn-ghost:hover:not(:disabled) {
  background: var(--color-bg);
  color: var(--color-text);
}
.btn-full {
  width: 100%;
}
/* ── Logo ── */
.logo-mark {
  width: 40px;
  height: 40px;
  border-radius: var(--radius);
  background: var(--color-primary);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.85rem;
  letter-spacing: 0.02em;
  flex-shrink: 0;
}
.logo-mark.sm {
  width: 32px;
  height: 32px;
  font-size: 0.75rem;
}
/* ── Login ── */
.login-page {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: linear-gradient(160deg, #e8f1f8 0%, var(--color-bg) 50%);
}
.login-card {
  width: 100%;
  max-width: 400px;
  background: var(--color-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow);
  padding: 2rem;
}
.login-header {
  text-align: center;
  margin-bottom: 1.75rem;
}
.login-header .logo-mark {
  margin: 0 auto 1rem;
}
.login-header h1 {
  font-size: 1.35rem;
  font-weight: 600;
}
.login-header p {
  color: var(--color-text-muted);
  font-size: 0.9rem;
  margin-top: 0.25rem;
}
.login-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.login-form label {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--color-text-muted);
}
.login-form input {
  padding: 0.6rem 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  font-size: 0.95rem;
  font-family: inherit;
  transition: border-color 0.15s;
}
.login-form input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px var(--color-primary-light);
}
.login-divider {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 1.25rem 0;
  color: var(--color-text-muted);
  font-size: 0.8rem;
}
.login-divider::before,
.login-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: var(--color-border);
}
/* ── Alerts ── */
.alert {
  padding: 0.75rem 1rem;
  border-radius: var(--radius);
  font-size: 0.9rem;
  margin-bottom: 1rem;
}
.alert-error {
  background: var(--color-error-bg);
  color: var(--color-error);
  border: 1px solid #f5c6c2;
}
.alert-success {
  background: var(--color-success-bg);
  color: var(--color-success);
  border: 1px solid #b8dfc9;
}
/* ── Layout ── */
.app-layout {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
.app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1.5rem;
  background: var(--color-surface);
  border-bottom: 1px solid var(--color-border);
}
.header-brand {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 600;
  font-size: 1rem;
}
.header-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.user-menu {
  position: relative;
}
.user-label {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.85rem;
  color: var(--color-text-muted);
  background: none;
  border: none;
  padding: 0.25rem 0.4rem;
  border-radius: var(--radius);
  cursor: pointer;
  font-family: inherit;
}
.user-label:hover,
.user-label.is-open {
  color: var(--color-text);
  background: var(--color-bg);
}
.user-menu-panel {
  position: absolute;
  top: calc(100% + 0.4rem);
  right: 0;
  z-index: 40;
  min-width: 240px;
  padding: 0.85rem 1rem;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
}
.user-menu-title {
  margin: 0 0 0.65rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.user-menu-details {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}
.user-menu-details > div {
  display: grid;
  grid-template-columns: 4.5rem 1fr;
  gap: 0.5rem;
  align-items: baseline;
}
.user-menu-details dt {
  margin: 0;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--color-text-muted);
}
.user-menu-details dd {
  margin: 0;
  font-size: 0.9rem;
  color: var(--color-text);
  word-break: break-word;
}
.user-menu-muted {
  margin: 0;
  font-size: 0.85rem;
  color: var(--color-text-muted);
}
.user-menu-error {
  margin: 0;
  font-size: 0.85rem;
  color: #b91c1c;
}
.app-nav {
  display: flex;
  gap: 0.25rem;
  padding: 0.5rem 1.5rem;
  background: var(--color-surface);
  border-bottom: 1px solid var(--color-border);
}
.nav-link {
  padding: 0.45rem 0.9rem;
  border-radius: var(--radius);
  text-decoration: none;
  color: var(--color-text-muted);
  font-size: 0.9rem;
  font-weight: 500;
  transition: background 0.15s, color 0.15s;
}
.nav-link:hover {
  background: var(--color-bg);
  color: var(--color-text);
}
.nav-link-primary {
  color: var(--color-primary);
  background: var(--color-primary-light);
}
.nav-link-primary:hover {
  background: #d4e6f3;
  color: var(--color-primary-hover);
}
.app-main {
  flex: 1;
  padding: 1.5rem;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}
/* ── Page ── */
.page-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 1.25rem;
}
.referral-help-note {
  flex: 0 1 16rem;
  margin: 0.15rem 0 0 auto;
  color: var(--color-text-muted);
  font-size: 0.78rem;
  line-height: 1.4;
  text-align: right;
}
.referral-help-note a {
  color: var(--color-primary);
  font-weight: 600;
  text-decoration: none;
}
.referral-help-note a:hover {
  text-decoration: underline;
}
.referral-help-note-rest {
  display: block;
}
.page-header h1 {
  font-size: 1.5rem;
  font-weight: 600;
}
.page-subtitle {
  color: var(--color-text-muted);
  font-size: 0.9rem;
  margin-top: 0.15rem;
}
.result-count {
  font-size: 0.85rem;
  color: var(--color-text-muted);
  padding-top: 0.35rem;
}
/* ── Dashboard overview ── */
.dashboard-overview {
  margin-bottom: 1rem;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}
.dashboard-overview-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem 0.75rem;
}
.dashboard-overview-toggle {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: baseline;
  gap: 0.65rem 1rem;
  flex: 1 1 14rem;
  min-width: 0;
  padding: 0.85rem 1rem;
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
  color: inherit;
}
.dashboard-overview-toggle:hover {
  background: #f7faff;
}
.dashboard-overview-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.5rem 0.75rem;
  padding: 0.45rem 1rem 0.65rem;
}
.dashboard-overview-title {
  font-size: 0.95rem;
  font-weight: 650;
  color: #243447;
}
.dashboard-overview-subtitle {
  font-size: 0.8rem;
  color: var(--color-text-muted);
}
.dashboard-overview-chevron {
  font-size: 0.85rem;
  color: #5e6f84;
  justify-self: end;
}
.dashboard-overview-body {
  padding: 0 1rem 1rem;
  border-top: 1px solid var(--color-border);
}
.overview-scope-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem 1rem;
  margin-top: 0.85rem;
}
.overview-scope-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  min-width: min(100%, 16rem);
  flex: 1 1 14rem;
}
.overview-scope-field-compact {
  flex: 0 1 auto;
  min-width: 8.5rem;
}
.overview-scope-field-compact .overview-scope-select {
  max-width: 18rem;
  min-width: 8.5rem;
}
.overview-scope-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.overview-scope-select {
  width: 100%;
  max-width: 22rem;
  padding: 0.4rem 0.55rem;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  background: #fff;
  font: inherit;
  font-size: 0.875rem;
  color: var(--color-text);
}
.overview-scope-hint {
  font-size: 0.8rem;
  color: var(--color-text-muted);
  padding-bottom: 0.35rem;
}
.overview-scope-hint-error {
  color: var(--color-error, #e43045);
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}
.overview-status {
  margin: 0.85rem 0 0;
  font-size: 0.875rem;
  color: var(--color-text-muted);
}
.overview-status-error {
  color: var(--color-error, #e43045);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}
.overview-metric-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(9.5rem, 1fr));
  gap: 0.75rem;
  margin-top: 0.9rem;
}
.overview-metric {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.7rem 0.8rem;
  border: 1px solid #e7eef6;
  border-radius: var(--radius-md, 8px);
  background: #fbfcfe;
  min-height: 4.25rem;
}
.overview-metric-label {
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #5e6f84;
}
.overview-metric-value {
  font-size: 1.25rem;
  font-weight: 650;
  color: #243447;
  font-variant-numeric: tabular-nums;
  line-height: 1.2;
}
.overview-metric-hint {
  font-size: 0.72rem;
  color: var(--color-text-muted);
}
.overview-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.75rem;
}
/* ── Filters ── */
.filters-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: flex-end;
  padding: 1rem;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  margin-bottom: 1rem;
}
.filter-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--color-text-muted);
  min-width: 140px;
}
.filter-field input,
.filter-field select {
  padding: 0.45rem 0.6rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  font-size: 0.9rem;
  font-family: inherit;
  background: var(--color-surface);
}
.filter-field input:focus,
.filter-field select:focus {
  outline: none;
  border-color: var(--color-primary);
}
.filter-field-grow {
  flex: 1 1 220px;
  min-width: 200px;
}
.filter-clear {
  align-self: flex-end;
  margin-bottom: 1px;
}
/* ── Table ── */
.table-wrap {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}
.referrals-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}
.referrals-table th {
  text-align: left;
  padding: 0.75rem 1rem;
  background: var(--color-bg);
  font-weight: 600;
  font-size: 0.8rem;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  border-bottom: 1px solid var(--color-border);
}
.referrals-table td {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--color-border);
}
.referrals-table tbody tr:last-child td {
  border-bottom: none;
}
.referrals-table tbody tr:hover {
  background: #fafbfc;
}
.referrals-table th.col-status,
.referrals-table td.col-status {
  min-width: 9rem;
}
.referrals-table th.col-date,
.referrals-table td.col-date {
  min-width: 8rem;
}
.referrals-table th.col-datetime,
.referrals-table td.col-datetime {
  min-width: 11rem;
  white-space: nowrap;
}
.referrals-table th.col-created-by,
.referrals-table td.col-created-by {
  min-width: 8rem;
}
.referrals-table th.col-owner,
.referrals-table td.col-owner {
  min-width: 8rem;
}
.mono {
  font-family: 'Cascadia Code', 'Consolas', monospace;
  font-size: 0.82rem;
}
.table-empty {
  padding: 3rem;
  text-align: center;
  color: var(--color-text-muted);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
}
.text-muted {
  color: var(--color-text-muted);
}
.referral-id-link {
  color: var(--color-primary);
  font-weight: 600;
  text-decoration: none;
}
.referral-id-link:hover {
  text-decoration: underline;
}
/* Mobile card list — shown under 768px; table stays on desktop. */
.referrals-cards {
  display: none;
}
.referrals-cards-sort {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-bottom: 0.75rem;
}
.referrals-cards-sort .th-sort {
  padding: 0.4rem 0.65rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm, 6px);
  background: var(--color-surface);
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}
.referrals-cards-sort .th-sort-active {
  border-color: var(--color-primary);
  background: #edf6ff;
  color: var(--color-primary);
}
.referrals-card-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}
.referral-card {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: 0.9rem 1rem;
}
.referral-card-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem 0.75rem;
  margin-bottom: 0.75rem;
}
.referral-card-head .referral-id-link {
  font-size: 1rem;
}
.referral-card-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem 1.25rem;
  margin: 0;
}
.referral-card-meta > div {
  flex: 1 1 7.5rem;
  min-width: 0;
}
.referral-card-meta dt {
  margin: 0 0 0.15rem;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--color-text-muted);
}
.referral-card-meta dd {
  margin: 0;
  font-size: 0.875rem;
  color: var(--color-text);
  overflow-wrap: anywhere;
}
/* ── Referral detail ── */
.back-link {
  display: inline-block;
  margin-bottom: 0.5rem;
  color: var(--color-text-muted);
  text-decoration: none;
  font-size: 0.85rem;
}
.back-link:hover {
  color: var(--color-primary);
}
.referral-detail {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}
.detail-card {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: 1.25rem 1.5rem;
}
.detail-card h2 {
  margin: 0 0 1rem;
  font-size: 1.05rem;
}
.scheduled-appointments-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}
.scheduled-appointment {
  padding: 0.85rem 1rem;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  background: #fafbfd;
}
.scheduled-appointment .detail-meta {
  margin: 0;
}
.detail-card-heading {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1rem;
}
.detail-card-heading h2 {
  margin: 0;
}
.detail-attachment-upload {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.detail-attachment-file-input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.detail-attachment-upload-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  padding: 0.45rem 0.95rem;
  border: 1px solid #c5daf5;
  border-radius: 6px;
  background: #e6f1ff;
  color: #000;
  font: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: none;
  cursor: pointer;
}
.detail-attachment-upload-btn:hover:not(:disabled) {
  background: #d4e6fb;
  border-color: #b7d0f0;
  color: #000;
  text-decoration: none;
}
.detail-attachment-upload-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(230, 241, 255, 0.8);
}
.detail-attachment-upload-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.detail-attachment-success {
  margin: 0 0 0.75rem;
  color: var(--color-success, #15803d);
  font-size: 0.88rem;
}
.detail-meta {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1rem;
  margin: 0;
}
.detail-meta dt {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--color-text-muted);
  margin-bottom: 0.2rem;
}
.detail-meta dd {
  margin: 0;
  font-size: 0.9rem;
}
.persons-involved-badges {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.person-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  max-width: 100%;
  padding: 0.4rem 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: 999px;
  background: var(--color-bg, #f8fafc);
  color: inherit;
  text-decoration: none;
  font-size: 0.85rem;
  line-height: 1.2;
}
.person-badge.is-patient {
  border-color: var(--color-primary);
  border-width: 2px;
  background: #e8f2ff;
  box-shadow: 0 0 0 1px rgba(43, 108, 176, 0.12);
}
a.person-badge:hover {
  border-color: var(--color-primary);
  background: #edf6ff;
}
a.person-badge.is-patient:hover {
  background: #dcecff;
}
.person-badge-name {
  font-weight: 600;
  color: var(--color-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.person-badge-type {
  flex-shrink: 0;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--color-text-muted);
  font-variant-numeric: tabular-nums;
}
.referral-updates-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.referral-updates-new-count {
  display: inline-flex;
  align-items: center;
  margin-left: 0.55rem;
  padding: 0.12rem 0.5rem;
  border-radius: 999px;
  background: #edf6ff;
  border: 1px solid rgba(43, 108, 176, 0.28);
  color: var(--color-primary, #2b6cb0);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  vertical-align: middle;
}
.referral-update {
  --update-accent: var(--color-border);
  padding: 0.85rem 1rem;
  border: 1px solid var(--color-border);
  border-left: 3px solid var(--update-accent);
  border-radius: var(--radius-md, 8px);
  background: var(--color-bg, #f8fafc);
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}
.referral-update--adjuster {
  --update-accent: #2b6cb0;
}
.referral-update--admin {
  --update-accent: #6b46c1;
}
.referral-update--provider {
  --update-accent: #2f855a;
}
.referral-update--manager {
  --update-accent: #c05621;
}
.referral-update--inspire {
  --update-accent: #319795;
}
.referral-update--system {
  --update-accent: #718096;
}
.referral-update.is-new {
  background: #f3f8ff;
  box-shadow: none;
}
.referral-update-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.35rem 1rem;
  margin-bottom: 0.45rem;
  font-size: 0.78rem;
  color: var(--color-text-muted);
}
.referral-update-meta time {
  font-weight: 600;
  color: var(--color-text);
}
.referral-update-meta-left {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem;
}
.referral-update-type {
  display: inline-flex;
  align-items: center;
  padding: 0.06rem 0.4rem;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: rgba(255, 255, 255, 0.7);
  color: var(--update-accent, var(--color-text-muted));
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}
.referral-update-meta-right {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem;
}
.referral-update-new-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.08rem 0.4rem;
  border-radius: 999px;
  background: var(--color-primary, #2b6cb0);
  color: #fff;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.referral-update-by::before {
  content: 'by ';
  font-weight: 400;
  color: var(--color-text-muted);
}
.referral-update-description {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.45;
  color: var(--color-text);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.referral-updates-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.85rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--color-border);
}
.referral-post-update-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  padding: 0.45rem 0.95rem;
  border: 1px solid #c5daf5;
  border-radius: 6px;
  background: #e6f1ff;
  color: #000;
  font: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: none;
  cursor: pointer;
}
.referral-post-update-btn:hover:not(:disabled) {
  background: #d4e6fb;
  border-color: #b7d0f0;
  color: #000;
  text-decoration: none;
}
.referral-post-update-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(230, 241, 255, 0.8);
}
.referral-post-update-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
/* ── Form tiles ── */
.form-tile-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 1rem;
}
.form-tile {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  padding: 1rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-surface);
  cursor: pointer;
  text-align: left;
  font: inherit;
  transition: border-color 0.15s, box-shadow 0.15s, transform 0.05s;
}
.form-tile:hover {
  border-color: var(--color-primary);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}
.form-tile:active {
  transform: translateY(1px);
}
.form-tile-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: var(--radius);
  background: var(--color-primary-light);
  color: var(--color-primary);
}
.form-tile-body {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
}
.form-tile-title {
  font-weight: 600;
  font-size: 0.92rem;
  line-height: 1.3;
}
.form-tile-source {
  font-size: 0.8rem;
  color: var(--color-text-muted);
}
.form-tile-meta {
  font-size: 0.75rem;
  color: var(--color-text-muted);
}
/* ── Detail attachments ── */
.detail-attachment-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.detail-attachment-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.75rem 0.85rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md, 8px);
  background: var(--color-bg, #f8fafc);
}
.detail-attachment-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: var(--radius, 6px);
  background: var(--color-primary-light, #e0f2fe);
  color: var(--color-primary);
}
.detail-attachment-body {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
}
.detail-attachment-name {
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--color-text);
  word-break: break-word;
}
button.detail-attachment-link {
  color: var(--color-primary);
  text-decoration: none;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  font-weight: 600;
  font-size: 0.9rem;
  text-align: left;
  cursor: pointer;
  word-break: break-word;
}
button.detail-attachment-link:hover:not(:disabled) {
  text-decoration: underline;
}
button.detail-attachment-link:disabled {
  opacity: 0.7;
  cursor: wait;
}
.detail-attachment-download {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  padding: 0.45rem 0.95rem;
  border: 1px solid #c5daf5;
  border-radius: 6px;
  background: #e6f1ff;
  color: #000;
  font: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: none;
  cursor: pointer;
  align-self: flex-start;
  margin-top: 0.35rem;
}
.detail-attachment-download:hover:not(:disabled) {
  background: #d4e6fb;
  border-color: #b7d0f0;
  color: #000;
  text-decoration: none;
}
.detail-attachment-download:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(230, 241, 255, 0.8);
}
.detail-attachment-download:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.detail-attachment-download:disabled {
  opacity: 0.7;
  cursor: wait;
}
.detail-attachment-error {
  margin: 0 0 0.75rem;
  color: var(--color-error);
  font-size: 0.85rem;
}
.detail-attachment-meta {
  font-size: 0.78rem;
  color: var(--color-text-muted);
}
.detail-forms-hint {
  margin: 0 0 0.75rem;
}
/* ── Form modal ── */
.form-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 3vh 1rem;
  background: rgba(15, 23, 42, 0.45);
  overflow-y: auto;
}
.form-modal {
  width: 100%;
  max-width: 920px;
  background: var(--color-bg);
  border-radius: var(--radius-lg);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  max-height: 94vh;
}
.form-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--color-border);
  background: var(--color-surface);
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
}
.form-modal-header h2 {
  margin: 0;
  font-size: 1.05rem;
}
.form-modal-source {
  font-size: 0.8rem;
  color: var(--color-text-muted);
}
.form-modal-close {
  border: none;
  background: none;
  font-size: 1.1rem;
  line-height: 1;
  padding: 0.35rem 0.5rem;
  border-radius: var(--radius);
  cursor: pointer;
  color: var(--color-text-muted);
}
.form-modal-close:hover {
  background: var(--color-bg);
  color: var(--color-text);
}
.form-modal-close:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.form-modal-body {
  overflow-y: auto;
  padding: 0.5rem 1rem 1rem;
}
/* ── Pagination ── */
.pagination {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}
.pagination-info {
  grid-column: 1;
  justify-self: start;
  font-size: 0.85rem;
  color: var(--color-text-muted);
}
.pagination-controls {
  grid-column: 2;
  justify-self: center;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.pagination-page {
  font-size: 0.85rem;
  color: var(--color-text-muted);
}
.pagination-controls .btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.pagination-pages {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.pagination-page-btn {
  min-width: 2rem;
  height: 2rem;
  padding: 0 0.5rem;
  border: 1px solid var(--color-border);
  background: var(--color-surface, #fff);
  border-radius: var(--radius);
  font-size: 0.85rem;
  color: var(--color-text, #0f172a);
  cursor: pointer;
}
.pagination-page-btn:hover:not(:disabled):not(.active) {
  background: var(--color-bg);
}
.pagination-page-btn.active {
  background: var(--color-primary);
  border-color: var(--color-primary);
  color: #fff;
  font-weight: 600;
}
.pagination-page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.pagination-gap {
  padding: 0 0.25rem;
  color: var(--color-text-muted);
}
.pagination-jump {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.85rem;
  color: var(--color-text-muted);
}
.pagination-jump input {
  width: 4rem;
  height: 2rem;
  padding: 0 0.5rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  font-size: 0.85rem;
}
/* Sortable column headers */
.referrals-table th {
  padding: 0;
}
.th-sort {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  width: 100%;
  padding: 0.75rem 1rem;
  background: none;
  border: none;
  cursor: pointer;
  font: inherit;
  font-weight: 600;
  font-size: 0.8rem;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.th-sort:hover {
  color: var(--color-text, #0f172a);
}
.th-sort-active {
  color: var(--color-primary);
}
.th-sort-arrow {
  font-size: 0.7rem;
  opacity: 0.5;
}
.th-sort-active .th-sort-arrow {
  opacity: 1;
}
/* ── Badges ── */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.28rem 0.72rem 0.28rem 0.55rem;
  border-radius: 999px;
  background: #eef1f4;
  color: #8b939e;
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1.2;
}
.status-badge-dot {
  width: 0.45rem;
  height: 0.45rem;
  flex-shrink: 0;
  border-radius: 50%;
  background: currentColor;
}
.status-tone-received {
  background: #e7f2ff;
  color: #2f7de1;
}
.status-tone-scheduling {
  background: #fff3dc;
  color: #c48a12;
}
.status-tone-scheduled {
  background: #e5f7ec;
  color: #2f9d57;
}
.status-tone-seen,
.status-tone-neutral {
  background: #eef1f4;
  color: #8b939e;
}
.status-tone-unable {
  background: #fdecec;
  color: #e23b3b;
}
.type-badge {
  display: inline-block;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
}
.status-0 {
  background: var(--color-primary-light);
  color: var(--color-primary);
}
.status-1 {
  background: #fef9e7;
  color: var(--color-warning);
}
.status-2 {
  background: var(--color-success-bg);
  color: var(--color-success);
}
.status-3 {
  background: #f0f0f5;
  color: #555;
}
/* ── Tabs ── */
.tab-bar {
  display: flex;
  gap: 0.25rem;
  margin-bottom: 1.25rem;
  border-bottom: 1px solid var(--color-border);
}
.tab {
  padding: 0.6rem 1.1rem;
  border: none;
  background: none;
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--color-text-muted);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  transition: color 0.15s;
}
.tab:hover {
  color: var(--color-text);
}
.tab.active {
  color: var(--color-primary);
  border-bottom-color: var(--color-primary);
}
/* ── Form switcher (referral + added supporting forms) ── */
.form-switcher {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  margin: -0.5rem 0 1.25rem;
}
.form-switcher-item {
  display: inline-flex;
  align-items: stretch;
  max-width: 100%;
  border: 1px solid var(--color-border);
  border-radius: 999px;
  background: var(--color-surface, #fff);
  overflow: hidden;
}
.form-switcher-item.active {
  border-color: var(--color-primary);
  background: #eef2ff;
}
.form-switcher-tab {
  padding: 0.45rem 0.9rem;
  border: 1px solid var(--color-border);
  border-radius: 999px;
  background: var(--color-surface, #fff);
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--color-text-muted);
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s, background 0.15s;
}
.form-switcher-item .form-switcher-tab {
  border: 0;
  border-radius: 0;
  background: transparent;
}
.form-switcher-item.active .form-switcher-tab {
  color: var(--color-primary);
}
.form-switcher-tab:hover {
  color: var(--color-text);
  border-color: var(--color-text-muted);
}
.form-switcher-tab.active {
  color: var(--color-primary);
  border-color: var(--color-primary);
  background: #eef2ff;
}
.form-switcher-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.6rem;
  padding: 0 0.45rem 0 0.15rem;
  border: 0;
  background: transparent;
  color: var(--color-text-muted);
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
}
.form-switcher-remove:hover {
  color: var(--color-error, #e43045);
}
.form-switcher-tab--add {
  border-style: dashed;
}
.form-switcher-tab--add.is-open,
.form-switcher-tab--add:hover {
  color: var(--color-primary);
  border-color: var(--color-primary);
}
.add-form-menu {
  position: relative;
}
.add-form-menu-list {
  position: absolute;
  top: calc(100% + 0.4rem);
  left: 0;
  z-index: 60;
  min-width: 16rem;
  max-width: min(22rem, 80vw);
  margin: 0;
  padding: 0.35rem;
  list-style: none;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg, 10px);
  background: var(--color-surface, #fff);
  box-shadow: var(--shadow);
}
.add-form-menu-option {
  display: block;
  width: 100%;
  padding: 0.55rem 0.7rem;
  border: 0;
  border-radius: var(--radius, 6px);
  background: transparent;
  color: var(--color-text);
  font: inherit;
  font-size: 0.85rem;
  text-align: left;
  cursor: pointer;
}
.add-form-menu-option:hover {
  background: #eef2ff;
  color: var(--color-primary);
}
/* New Referral: compact sticky chrome + form switcher */
.page--new-referral .new-referral-chrome {
  position: sticky;
  top: 0;
  z-index: 50;
  margin: -0.35rem 0 0.85rem;
  padding: 0.35rem 0 0.65rem;
  background: var(--color-bg);
  border-bottom: 1px solid var(--color-border);
  box-shadow: 0 8px 12px -10px rgba(7, 51, 127, 0.18);
}
.page--new-referral .page-header--compact {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35rem 0.75rem;
  margin-bottom: 0.35rem;
}
.page--new-referral .page-header--compact h1 {
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
}
.page--new-referral .page-header--compact .page-subtitle {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.3;
  color: var(--color-text-muted);
}
.page--new-referral .tab-bar {
  margin-bottom: 0.5rem;
}
.page--new-referral .tab {
  padding: 0.4rem 0.85rem;
  font-size: 0.82rem;
}
.page--new-referral .form-switcher {
  margin: 0;
  gap: 0.35rem;
}
.page--new-referral .new-referral-mode {
  display: inline-flex;
  gap: 0;
  margin-bottom: 1rem;
  padding: 0.2rem;
  border: 1px solid #d9e5f2;
  border-bottom: 1px solid #d9e5f2;
  border-radius: 10px;
  background: #fff;
}
.page--new-referral .new-referral-mode .tab {
  margin: 0;
  padding: 0.4rem 0.9rem;
  border: 0;
  border-radius: 8px;
  color: #68788e;
  font-size: 0.85rem;
  font-weight: 600;
}
.page--new-referral .new-referral-mode .tab.active {
  color: #07337f;
  background: #e7f1ff;
}
.page--new-referral .new-referral-workspace {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 1rem;
  align-items: start;
}
.page--new-referral .new-referral-workspace.is-assistant-hidden {
  grid-template-columns: minmax(0, 1fr);
}
.page--new-referral .new-referral-form {
  min-width: 0;
}
.page--new-referral .assistant-show-fab {
  position: fixed;
  right: 1.25rem;
  bottom: 5.5rem;
  z-index: 30;
  border: 1px solid #2379f4;
  border-radius: 999px;
  background: #2379f4;
  color: #fff;
  font: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.55rem 0.9rem;
  box-shadow: 0 6px 16px rgba(35, 121, 244, 0.28);
  cursor: pointer;
}
.page--new-referral .assistant-show-fab:hover {
  background: #1267dc;
}
.page--new-referral .referral-steps {
  display: flex;
  gap: 0.75rem;
  margin: 0 0 0.85rem;
  padding: 0;
  list-style: none;
}
.page--new-referral .referral-step {
  flex: 1;
  min-width: 0;
}
.page--new-referral .referral-step-btn {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.45rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: #68788e;
  font: inherit;
  font-size: 0.82rem;
  text-align: left;
  cursor: pointer;
}
.page--new-referral .referral-step-index {
  display: inline-flex;
  width: 1.35rem;
  height: 1.35rem;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #e6ecf2;
  color: #68788e;
  font-size: 0.75rem;
  font-weight: 700;
}
.page--new-referral .referral-step-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.page--new-referral .referral-step.is-current .referral-step-index,
.page--new-referral .referral-step.is-done .referral-step-index {
  background: #2379f4;
  color: #fff;
}
.page--new-referral .referral-step.is-current .referral-step-label {
  color: #07337f;
  font-weight: 600;
}
.page--new-referral .referral-step.is-current .referral-step-btn {
  box-shadow: inset 0 -2px 0 #2379f4;
  padding-bottom: 0.35rem;
}
.page--new-referral .new-referral-nav {
  position: sticky;
  bottom: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 0.75rem;
  padding: 0.75rem 0.15rem 0.15rem;
  background: linear-gradient(180deg, rgba(237, 247, 255, 0) 0%, #edf7ff 28%);
}
.page--new-referral .new-referral-draft {
  color: #68788e;
  font-size: 0.82rem;
}
.page--new-referral .new-referral-nav-actions {
  display: flex;
  gap: 0.5rem;
}
.page--new-referral .sd-action-bar {
  display: none;
}
.page--new-referral .sd-selectbase {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}
.page--new-referral .sd-selectbase .sd-item {
  flex: 1 1 220px;
  margin: 0;
  padding: 0.85rem 1rem;
  border: 1px solid #d9e5f2;
  border-radius: 10px;
  background: #fff;
}
.page--new-referral .sd-selectbase .sd-item--checked {
  border-color: #2379f4;
  background: #f4f8ff;
  box-shadow: 0 0 0 1px #2379f4;
}
.page--new-referral .sd-html {
  margin-bottom: 0.85rem;
  font-size: 0.88rem;
  line-height: 1.45;
}
.page--new-referral .form-switcher-tab {
  padding: 0.3rem 0.7rem;
  font-size: 0.78rem;
}
.page--new-referral .form-switcher-remove {
  min-width: 1.35rem;
  font-size: 0.95rem;
}
.page--new-referral .add-form-menu-option {
  font-size: 0.8rem;
}
@media (max-width: 900px) {
  .page--new-referral .new-referral-workspace {
    grid-template-columns: 1fr;
  }
  .referral-help-note {
    flex-basis: 100%;
    margin-left: 0;
    text-align: left;
  }
}
.form-load-error {
  padding: 2rem;
  text-align: center;
  color: var(--color-error);
}
.form-load-error p {
  margin-bottom: 1rem;
}
/* ── SurveyJS overrides ── */
.survey-container {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: 0.75rem;
  position: relative;
}
.survey-container .sd-root-modern {
  --sjs-primary-backcolor: var(--color-primary);
  --sjs-primary-backcolor-dark: var(--color-primary-hover);
  --sjs-general-backcolor: var(--color-surface);
  --sjs-border-default: var(--color-border);
}
.survey-container .sd-root-modern,
.survey-panel-side .sd-root-modern,
.form-modal .sd-root-modern {
  --sjs-base-unit: 6px;
  --sd-base-padding: 5px;
  --sd-base-vertical-padding: 8px;
  --sd-page-vertical-padding: 8px;
}
.survey-container .sd-root-modern,
.survey-panel-side .sd-root-modern,
.form-modal .sd-root-modern,
.survey-container .sd-container-modern,
.survey-panel-side .sd-container-modern,
.form-modal .sd-container-modern,
.survey-container .sd-body,
.survey-panel-side .sd-body,
.form-modal .sd-body,
.survey-container .sd-body__page,
.survey-panel-side .sd-body__page,
.form-modal .sd-body__page,
.survey-container .sd-page,
.survey-panel-side .sd-page,
.form-modal .sd-page {
  max-width: none;
  width: 100%;
}
.survey-container .sd-element,
.survey-panel-side .sd-element,
.form-modal .sd-element,
.survey-container .sd-row,
.survey-panel-side .sd-row,
.form-modal .sd-row,
.survey-container .sd-question,
.survey-panel-side .sd-question,
.form-modal .sd-question {
  margin-top: 0.35rem;
  margin-bottom: 0.35rem;
}
.survey-container .sd-question__title,
.survey-panel-side .sd-question__title,
.form-modal .sd-question__title {
  margin-bottom: 0.2rem;
}
.survey-container .sd-question__description,
.survey-panel-side .sd-question__description,
.form-modal .sd-question__description {
  margin-top: 0.15rem;
}
.survey-container .sd-panel__title,
.survey-panel-side .sd-panel__title,
.form-modal .sd-panel__title,
.survey-container .sd-page__title,
.survey-panel-side .sd-page__title,
.form-modal .sd-page__title {
  margin-bottom: 0.35rem;
}
.overlay-msg {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.78);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  z-index: 10;
  border-radius: var(--radius-lg);
}
/* Pin to the viewport so long forms still show the spinner on-screen. */
.overlay-msg--viewport {
  position: fixed;
  inset: 0;
  z-index: 2000;
  border-radius: 0;
  background: rgba(15, 23, 42, 0.35);
}
.overlay-msg-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.85rem;
  padding: 1.25rem 1.5rem;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.18);
  color: var(--color-text);
  font-size: 0.95rem;
}
.overlay-msg-content .spinner {
  width: 36px;
  height: 36px;
}
/* ── Upload ── */
.upload-panel {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: 2rem;
}
.upload-test-note {
  margin: 1rem 0 0;
  font-size: 0.875rem;
  color: var(--color-text-muted, #64748b);
}
.upload-test-note code {
  font-size: 0.8125rem;
}
.upload-dropzone input[type='file'] {
  display: none;
}
.upload-dropzone label {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 3rem 2rem;
  border: 2px dashed var(--color-border);
  border-radius: var(--radius-lg);
  cursor: pointer;
  text-align: center;
  transition: border-color 0.15s, background 0.15s;
}
.upload-dropzone label:hover {
  border-color: var(--color-primary);
  background: var(--color-primary-light);
}
.upload-dropzone strong {
  font-size: 1rem;
}
.upload-dropzone span {
  font-size: 0.85rem;
  color: var(--color-text-muted);
}
.upload-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.25rem;
}
/* ── Loading ── */
.loading-screen {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  color: var(--color-text-muted);
}
.spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--color-border);
  border-top-color: var(--color-primary);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
/* ── Responsive ── */
@media (max-width: 768px) {
  .app-main {
    padding: 1rem;
  }
  .filters-bar {
    flex-direction: column;
    align-items: stretch;
  }
  .filter-field {
    min-width: unset;
  }
  .referrals-table-desktop {
    display: none;
  }
  .referrals-cards {
    display: block;
  }
  .page-header {
    flex-direction: column;
    gap: 0.5rem;
  }
}
/* ── Figma-aligned visual system ── */
body {
  background: #edf7ff;
  font-size: 14px;
}
a:focus-visible,
button:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible {
  outline: 3px solid rgba(35, 121, 244, 0.28);
  outline-offset: 2px;
}
.btn {
  min-height: 36px;
  padding: 0.55rem 1.15rem;
  border-radius: 6px;
  font-weight: 600;
  letter-spacing: 0.005em;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, transform 0.15s ease;
}
.btn:active:not(:disabled) {
  transform: translateY(1px);
}
.btn-primary {
  background: #2379f4;
  box-shadow: 0 4px 10px rgba(35, 121, 244, 0.2);
}
.btn-secondary {
  color: #07337f;
  border-color: #c8d6e5;
}
.btn-ghost {
  color: #07337f;
  background: #ffffff;
}
/* Login */
.login-page {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(420px, 576px);
  min-height: 100vh;
  padding: 0;
  background: #ffffff;
}
.login-visual {
  position: relative;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  padding: clamp(2rem, 4vw, 4rem);
  color: #fff;
  background: #0b1932;
}
.login-visual::before {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
  background-size: 46px 46px;
  content: '';
  -webkit-mask-image: linear-gradient(to bottom, #000, transparent 85%);
  mask-image: linear-gradient(to bottom, #000, transparent 85%);
}
.login-visual p {
  position: relative;
  z-index: 1;
  margin: 0;
  color: rgba(255, 255, 255, 0.68);
  font-size: 0.85rem;
  letter-spacing: 0.04em;
}
.login-visual-brand {
  position: relative;
  z-index: 1;
  display: block;
  width: 200px;
  object-fit: contain;
}
.login-illustration {
  position: absolute;
  z-index: 0;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  filter: drop-shadow(0 28px 45px rgba(0, 0, 0, 0.24));
}
.login-panel {
  position: relative;
  display: grid;
  width: 100%;
  max-width: 576px;
  min-height: 100vh;
  justify-self: end;
  place-items: center;
  padding: 3rem clamp(2rem, 5vw, 4.5rem) 5rem;
}
.login-card {
  width: 100%;
  max-width: 430px;
  padding: 0;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}
.login-header {
  margin-bottom: 2rem;
  text-align: center;
}
.login-header h1 {
  margin-top: 1.5rem;
  color: #1d2b3c;
  font-size: clamp(1.45rem, 2vw, 1.85rem);
  font-weight: 700;
  letter-spacing: -0.025em;
}
.login-header p {
  margin-top: 0.5rem;
  color: #68788e;
}
.login-logo {
  display: inline-block;
  max-height: 100px;
  object-fit: contain;
}
.login-form {
  gap: 1.15rem;
}
.login-form label {
  gap: 0.45rem;
  color: #1d2b3c;
  font-size: 0.8rem;
  font-weight: 600;
}
.login-form input {
  min-height: 44px;
  padding: 0.7rem 0.85rem;
  border-color: #cdd8e4;
  border-radius: 6px;
  color: #1d2b3c;
}
.login-form input:focus {
  outline: none;
  border-color: #2379f4;
  box-shadow: 0 0 0 3px rgba(35, 121, 244, 0.16);
}
.login-form .btn {
  min-height: 42px;
  margin-top: 0.25rem;
}
.login-divider {
  margin: 1.4rem 0;
}
.footer-need-help {
  position: absolute;
  right: clamp(2rem, 5vw, 4.5rem);
  bottom: 1.5rem;
  left: clamp(2rem, 5vw, 4.5rem);
  color: #68788e;
  font-size: 0.82rem;
  text-align: left;
}
.footer-need-help a {
  color: #2671ff;
  font-weight: 500;
  text-decoration: none;
}
.footer-need-help a:hover {
  text-decoration: underline;
}
/* Shared shell */
.app-header {
  min-height: 72px;
  padding: 0;
  border: 0;
  border-bottom: 1px solid #c5d0dc;
  background: linear-gradient(180deg, #f4f7fa 0%, #e6ecf2 100%);
}
.app-header-inner,
.app-nav-inner {
  display: flex;
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  align-items: center;
  justify-content: space-between;
  padding-inline: clamp(1rem, 3vw, 2.5rem);
}
.app-header-inner {
  position: relative;
  min-height: 72px;
}
.header-brand {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  color: #07337f;
  font-size: 0.92rem;
  text-decoration: none;
  z-index: 1;
}
.header-logo {
  width: auto;
  height: 34px;
  object-fit: contain;
  /* SVG wordmark is white; tint to navy on the light header. */
  filter: brightness(0) saturate(100%) invert(14%) sepia(55%) saturate(2200%) hue-rotate(199deg) brightness(92%) contrast(101%);
}
.header-client-logo {
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  transform: translateX(-50%);
  height: 100%;
  width: auto;
  max-height: 100%;
  object-fit: contain;
  object-position: center;
  border-radius: 0;
  box-shadow: none;
  pointer-events: none;
}
.header-brand-divider {
  width: 1px;
  height: 24px;
  margin-inline: 0.15rem;
  background: rgba(7, 51, 127, 0.22);
}
.header-product {
  font-weight: 600;
}
.header-actions {
  gap: 0.85rem;
  z-index: 1;
}
.user-label {
  color: rgba(7, 51, 127, 0.78);
  border-radius: 999px;
}
.user-label:hover,
.user-label.is-open {
  color: #07337f;
  background: rgba(7, 51, 127, 0.08);
}
.btn-header {
  min-height: 32px;
  padding: 0.35rem 0.9rem;
  border: 1px solid rgba(7, 51, 127, 0.35);
  color: #07337f;
  background: transparent;
}
.btn-header:hover {
  border-color: #07337f;
  background: rgba(7, 51, 127, 0.08);
}
.user-menu-panel {
  background: #ffffff;
  border: 1px solid #d9e5f2;
  border-radius: 10px;
  box-shadow: 0 8px 28px rgba(5, 40, 98, 0.08);
  top: calc(100% + 0.65rem);
}
.app-nav {
  min-height: 52px;
  padding: 0;
  background: #ffffff;
  border-bottom-color: #d9e5f2;
}
.app-nav-inner {
  min-height: 52px;
}
.nav-tabs {
  display: flex;
  align-self: stretch;
  align-items: center;
  gap: 0.25rem;
}
.nav-link {
  position: relative;
  display: inline-flex;
  min-height: 52px;
  align-items: center;
  padding: 0.55rem 0.7rem;
  border-radius: 0;
  color: #68788e;
  font-size: 0.8rem;
}
.nav-link::after {
  position: absolute;
  right: 0.7rem;
  bottom: -1px;
  left: 0.7rem;
  height: 2px;
  border-radius: 2px 2px 0 0;
  background: transparent;
  content: '';
}
.nav-link:hover {
  color: #2379f4;
  background: transparent;
}
.nav-link.active {
  color: #2379f4;
}
.nav-link.active::after {
  background: #2379f4;
}
.nav-link-primary {
  min-height: 34px;
  padding: 0.45rem 1rem;
  gap: 0.45rem;
  border-radius: 999px;
  color: #fff;
  background: #2379f4;
  box-shadow: 0 3px 9px rgba(35, 121, 244, 0.2);
}
.nav-link-primary::after {
  display: none;
}
.nav-link-primary:hover {
  color: #fff;
  background: #1267dc;
}
.nav-new-icon {
  display: inline-flex;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 1rem;
  line-height: 1;
}
.app-main {
  max-width: 1500px;
  padding: clamp(1.25rem, 3vw, 2.5rem);
}
.app-footer {
  width: 100%;
  margin-top: auto;
  padding: 0;
  border-top: 1px solid #dce7f6;
  color: #53647b;
  background: #f3f7ff;
}
.app-footer-inner {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
.app-footer-inner p {
  margin: 0;
  font-size: 0.75rem;
  line-height: 1.55;
}
.app-footer-inner a {
  color: #0b2f73;
  font-weight: 700;
  text-decoration: none;
}
.app-footer-inner a:hover {
  text-decoration: underline;
}
.app-footer-powered {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  width: 100%;
  margin: 0%;
  padding: 0.75rem clamp(1rem, 3vw, 2.5rem);
  background: #07337f;
  color: rgba(255, 255, 255, 0.78);
}
.app-footer-powered-label {
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}
.app-footer-powered-logo {
  width: auto;
  height: 36px;
  object-fit: contain;
}
.app-footer-privacy {
  max-width: 1180px;
  margin: 0.3rem auto 0 !important;
  font-size: 10px !important;
  line-height: 1.45 !important;
}
/* Content and data surfaces */
.page-header {
  margin-bottom: 1.5rem;
  align-items: center;
}
.page-header h1 {
  color: #1d2b3c;
  font-size: clamp(1.35rem, 2vw, 1.7rem);
  font-weight: 700;
  letter-spacing: -0.025em;
}
.page-subtitle {
  margin-top: 0.3rem;
  color: #68788e;
}
.result-count {
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  color: #07337f;
  background: #e4f0ff;
  font-weight: 600;
}
.filters-panel {
  margin-bottom: 1rem;
  overflow: hidden;
  border: 1px solid #d9e5f2;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 5px 18px rgba(7, 51, 127, 0.05);
}
.filters-toggle {
  display: flex;
  width: 100%;
  min-height: 48px;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1.15rem;
  border: 0;
  color: #1d2b3c;
  background: #ffffff;
  font: inherit;
  font-size: 0.85rem;
  font-weight: 700;
  cursor: pointer;
}
.filters-toggle:hover {
  background: #f8fbff;
}
.filters-toggle-meta {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
}
.filters-toggle-label {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}
.filters-icon {
  width: 17px;
  height: 17px;
  color: #2379f4;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.filters-active-count {
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  color: #2379f4;
  background: #e9f3ff;
  font-size: 0.7rem;
  font-weight: 600;
}
.filters-chevron {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  color: #2379f4;
  background: #e9f3ff;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  transition: transform 0.15s ease;
}
.filters-panel.is-expanded .filters-chevron {
  transform: rotate(180deg);
}
.filters-bar {
  margin: 0;
  padding: 1rem 1.15rem 1.15rem;
  border: 0;
  border-top: 1px solid #e7eef6;
  border-radius: 0;
  background: #fbfdff;
}
.filters-bar .filter-field {
  color: #68788e;
  font-size: 0.74rem;
  font-weight: 600;
}
.filters-bar .filter-field input,
.filters-bar .filter-field select {
  min-height: 38px;
  border-color: #cad7e4;
  border-radius: 6px;
  color: #1d2b3c;
}
.filters-bar .filter-field input:focus,
.filters-bar .filter-field select:focus {
  outline: none;
  border-color: #2379f4;
  box-shadow: 0 0 0 3px rgba(35, 121, 244, 0.16);
}
.filter-actions {
  display: flex;
  flex: 1 0 100%;
  align-self: flex-end;
  justify-content: flex-end;
  gap: 0.55rem;
  margin-top: 0.15rem;
  margin-left: 0;
}
.filter-actions .btn {
  min-width: 84px;
}
.table-wrap {
  border-color: #d9e5f2;
  border-top: 1px solid #d9e5f2;
  border-radius: 10px;
  box-shadow: 0 8px 28px rgba(5, 40, 98, 0.08);
}
.referrals-table {
  font-size: 0.82rem;
}
.referrals-table th {
  background: #f7faff;
  border-color: #d9e5f2;
}
.referrals-table td {
  padding: 0.7rem 1rem;
  border-color: #e7eef6;
  color: #344357;
}
.referrals-table tbody tr {
  transition: background 0.12s ease;
}
.referrals-table tbody tr:hover {
  background: #f3f8ff;
}
.th-sort {
  color: #5e6f84;
  font-size: 0.72rem;
  letter-spacing: 0.025em;
}
.referral-id-link {
  color: #2f64b8;
}
.detail-header-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
}
.detail-update-inspire-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  padding: 0.45rem 0.95rem;
  border: 1px solid #c5daf5;
  border-radius: 6px;
  background: #e6f1ff;
  color: #000;
  font: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: none;
  cursor: pointer;
}
.detail-update-inspire-btn:hover:not(:disabled) {
  background: #d4e6fb;
  border-color: #b7d0f0;
  color: #000;
  text-decoration: none;
}
.detail-update-inspire-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(230, 241, 255, 0.8);
}
.detail-update-inspire-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.update-inspire-modal {
  max-width: 520px;
  margin-top: 12vh;
}
.update-inspire-modal-body {
  padding: 1.1rem 1.25rem 1.25rem;
}
.detail-update-inspire-label {
  display: block;
  margin-bottom: 0.4rem;
  font-weight: 600;
  font-size: 0.9rem;
}
.detail-update-inspire-textarea {
  display: block;
  width: 100%;
  box-sizing: border-box;
  margin: 0 0 0.75rem;
  padding: 0.65rem 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  font: inherit;
  font-size: 0.9rem;
  line-height: 1.45;
  resize: vertical;
  min-height: 5.5rem;
  background: var(--color-surface, #fff);
  color: var(--color-text);
}
.detail-update-inspire-textarea:focus {
  outline: 2px solid var(--color-primary);
  outline-offset: 1px;
}
.detail-update-inspire-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}
.status-0 {
  color: #fff;
  background: #21833f;
}
.status-1 {
  color: #fff;
  background: #eea62b;
}
.status-2 {
  color: #fff;
  background: #858b95;
}
.status-3 {
  color: #fff;
  background: #eb3349;
}
.status-badge.status-0 {
  background: #e5f6eb;
  color: #1c7a38;
}
.status-badge.status-1 {
  background: #fff1d6;
  color: #c47d08;
}
.status-badge.status-2 {
  background: #eef1f4;
  color: #6d7580;
}
.status-badge.status-3 {
  background: #fde8eb;
  color: #d1263c;
}
.status-badge.status-tone-received {
  background: #e7f2ff;
  color: #1d6fd4;
}
.status-badge.status-tone-scheduling {
  background: #fff1d6;
  color: #c47d08;
}
.status-badge.status-tone-scheduled {
  background: #e5f6eb;
  color: #1c7a38;
}
.status-badge.status-tone-seen,
.status-badge.status-tone-neutral {
  background: #eef1f4;
  color: #6d7580;
}
.status-badge.status-tone-unable {
  background: #fde8eb;
  color: #d1263c;
}
.pagination {
  margin-top: 1.25rem;
  padding-inline: 0.25rem;
}
.pagination-controls {
  gap: 0.45rem;
}
.pagination-page-btn {
  border-radius: 5px;
}
.pagination-page-btn.active {
  background: #2379f4;
  border-color: #2379f4;
}
.pagination-jump input:focus {
  outline: none;
  border-color: #2379f4;
  box-shadow: 0 0 0 3px rgba(35, 121, 244, 0.16);
}
/* Details, tabs, forms, and overlays */
.back-link {
  color: #2379f4;
  font-weight: 600;
}
.referral-detail {
  gap: 1rem;
}
.detail-card {
  background: #ffffff;
  border: 1px solid #d9e5f2;
  border-radius: 10px;
  box-shadow: 0 8px 28px rgba(5, 40, 98, 0.08);
  padding: 1.35rem 1.5rem;
}
.detail-card h2 {
  padding-bottom: 0.8rem;
  border-bottom: 1px solid #e7eef6;
  color: #1d2b3c;
  font-size: 1rem;
}
.detail-meta {
  gap: 1.25rem 1.5rem;
}
.detail-meta dt {
  color: #68788e;
  font-size: 0.7rem;
  font-weight: 600;
}
.detail-meta dd {
  color: #1d2b3c;
  font-weight: 500;
}
.form-tile {
  border-color: #d9e5f2;
  box-shadow: 0 3px 12px rgba(5, 40, 98, 0.05);
}
.form-tile:hover {
  border-color: #2379f4;
  box-shadow: 0 7px 18px rgba(35, 121, 244, 0.12);
}
.form-tile-icon {
  color: #2379f4;
  background: #e6f1ff;
}
.tab-bar {
  border-color: #d9e5f2;
}
.tab {
  color: #68788e;
  font-size: 0.82rem;
  font-weight: 600;
}
.tab.active {
  color: #2379f4;
  border-bottom-color: #2379f4;
}
.survey-container,
.upload-panel {
  background: #ffffff;
  border: 1px solid #d9e5f2;
  border-radius: 10px;
  box-shadow: 0 8px 28px rgba(5, 40, 98, 0.08);
}
.survey-container .sd-root-modern,
.survey-panel-side .sd-root-modern,
.form-modal .sd-root-modern {
  --sjs-primary-backcolor: #2379f4;
  --sjs-primary-backcolor-dark: #1267dc;
  --sjs-primary-backcolor-light: #e9f3ff;
  --sjs-general-backcolor: #ffffff;
  --sjs-general-forecolor: #1d2b3c;
  --sjs-border-default: #d9e5f2;
  --sjs-font-family: var(--font);
  --sjs-base-unit: 6px;
  --sd-base-padding: 5px;
  --sd-base-vertical-padding: 8px;
  --sd-page-vertical-padding: 8px;
}
.upload-dropzone label {
  border-color: #b9cee3;
  background: #f8fbff;
}
.upload-dropzone label:hover {
  border-color: #2379f4;
  background: #edf6ff;
}
.alert {
  border-radius: 6px;
  box-shadow: 0 4px 14px rgba(5, 40, 98, 0.05);
}
.table-empty,
.form-load-error {
  border-color: #d9e5f2;
  background: #ffffff;
  box-shadow: 0 8px 28px rgba(5, 40, 98, 0.08);
}
.form-modal-overlay {
  background: rgba(5, 40, 98, 0.55);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
}
.form-modal {
  border: 1px solid rgba(255, 255, 255, 0.45);
  box-shadow: 0 28px 70px rgba(5, 40, 98, 0.35);
}
.loading-screen {
  color: #68788e;
  background: #edf7ff;
}
@media (max-width: 900px) {
  .login-visual {
    padding: 2rem;
  }
  .header-product,
  .header-brand-divider {
    display: none;
  }
  .pagination {
    grid-template-columns: 1fr;
    justify-items: center;
  }
  .pagination-info,
  .pagination-controls {
    grid-column: 1;
  }
  .pagination-controls {
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
  }
}
@media (max-width: 680px) {
  .login-page {
    display: block;
  }
  .login-visual {
    min-height: 150px;
    padding: 1.5rem;
  }
  .login-panel {
    min-height: calc(100vh - 150px);
    padding: 2.25rem 1.25rem 4.5rem;
  }
  .footer-need-help {
    right: 1.25rem;
    left: 1.25rem;
  }
  .app-header-inner {
    min-height: 64px;
  }
  .header-logo {
    height: 28px;
  }
  .header-client-logo {
    height: 100%;
    width: auto;
  }
  .header-product {
    max-width: 7.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .user-label-name {
    display: inline-block;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .app-nav-inner {
    padding-inline: 0.75rem;
  }
  .nav-link {
    padding-inline: 0.55rem;
  }
  .app-main {
    padding: 1rem 0.75rem 2rem;
  }
  .filters-panel {
    margin-bottom: 0.75rem;
  }
  .filters-bar {
    margin: 0;
    border-radius: 0;
  }
  .filter-actions {
    width: 100%;
    justify-content: flex-end;
    margin-left: 0;
  }
  .table-wrap {
    border-top: 1px solid #d9e5f2;
    border-radius: 10px;
  }
  .referral-card {
    border-color: #d9e5f2;
    box-shadow: 0 8px 28px rgba(5, 40, 98, 0.08);
  }
  .referrals-cards-sort .th-sort {
    border-color: #d9e5f2;
  }
  .detail-card {
    padding: 1rem;
  }
  .detail-meta {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .form-modal-overlay {
    padding: 0;
  }
  .form-modal {
    min-height: 100vh;
    max-height: none;
    border-radius: 0;
  }
}
@media (max-width: 430px) {
  .header-actions {
    gap: 0.35rem;
  }
  .header-brand-divider,
  .header-product {
    display: none;
  }
  .header-client-logo {
    height: 100%;
    width: auto;
  }
  .user-label {
    padding-inline: 0.25rem;
  }
  .user-label-name {
    max-width: 78px;
  }
  .btn-header {
    padding-inline: 0.7rem;
  }
  .nav-tabs .nav-link.active[aria-current='page'] {
    display: none;
  }
  .detail-meta {
    grid-template-columns: 1fr;
  }
}
@media (max-height: 720px) and (min-width: 681px) {
  .login-panel {
    padding-block: 1.25rem;
  }
  .login-header {
    margin-bottom: 1.25rem;
  }
  .login-header h1 {
    margin-top: 0.8rem;
  }
  .login-logo {
    width: 30px;
    height: 43px;
  }
  .login-form {
    gap: 0.75rem;
  }
  .login-divider {
    margin-block: 0.9rem;
  }
  .footer-need-help {
    bottom: 0.85rem;
  }
}
.page--new-referral .sd-root-modern .sd-title.sd-container-modern__title {
  padding: 0.15rem 0.2rem 0.9rem !important;
  background: transparent !important;
  color: #1d2b3c !important;
  text-align: left;
}
.page--new-referral .sd-root-modern .sd-title.sd-container-modern__title .sd-header__text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.45rem;
  text-align: left;
}
.page--new-referral .sd-root-modern .sd-title.sd-container-modern__title .sd-title,
.page--new-referral .sd-root-modern .sd-title.sd-container-modern__title .sd-title .sv-string-viewer {
  margin: 0;
  color: #1d2b3c !important;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.25;
  text-align: left;
}
.page--new-referral .sd-root-modern .sd-title.sd-container-modern__title .sd-description {
  display: block;
  max-width: 100%;
  margin: 0.35rem 0 0;
  padding: 0.65rem 0.85rem;
  border-left: 3px solid #e43045;
  border-radius: 8px;
  background: #fff6f5;
  color: #1d2b3c !important;
  font-size: 0.88rem;
  font-weight: 400;
  line-height: 1.45;
  text-align: left;
}
.page--new-referral .sd-root-modern .sd-title.sd-container-modern__title .sd-description .sv-string-viewer {
  color: inherit !important;
  font-size: inherit;
  font-weight: inherit;
  background: transparent;
}
/* FAF runtime step UI (google address + inline alert). */
.faf-google-address {
  width: 100%;
}
.faf-google-address-row {
  display: flex;
  gap: 0.5rem;
  align-items: stretch;
}
.faf-google-address-input {
  flex: 1 1 auto;
  width: 100%;
  min-height: 2.75rem;
  padding: 0.65rem 0.85rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm, 6px);
  background: var(--color-surface, #fff);
  color: var(--color-text);
  font: inherit;
}
.faf-google-address-input:focus {
  border-color: var(--color-primary);
  outline: 2px solid rgba(43, 108, 176, 0.18);
  outline-offset: 1px;
}
.faf-google-address-map-btn {
  flex: 0 0 auto;
  min-width: 4.25rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm, 6px);
  background: #f8fafc;
  color: var(--color-text);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}
.faf-google-address-map-btn:hover {
  border-color: var(--color-primary);
  background: #edf6ff;
}
.faf-google-address.has-error .faf-google-address-input {
  border-color: #dc2626;
}
.faf-inline-alert {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin: 0.35rem 0 0.65rem;
  padding: 0.55rem 0.75rem;
  border: 1px solid #f5c2c7;
  border-radius: var(--radius-sm, 6px);
  background: #fde8e8;
  color: #842029;
  font-size: 0.85rem;
  line-height: 1.35;
}
.faf-inline-alert-text {
  flex: 1 1 auto;
  white-space: pre-wrap;
  word-break: break-word;
}
.faf-inline-alert-close {
  flex: 0 0 auto;
  border: none;
  background: transparent;
  color: inherit;
  font-size: 1.1rem;
  line-height: 1;
  cursor: pointer;
  padding: 0 0.15rem;
  opacity: 0.75;
}
.faf-inline-alert-close:hover {
  opacity: 1;
}
.faf-google-map-overlay {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(15, 23, 42, 0.45);
}
.faf-google-map-dialog {
  width: min(720px, 100%);
  max-height: calc(100vh - 2rem);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: var(--radius-md, 8px);
  background: var(--color-surface, #fff);
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.28);
}
.faf-google-map-dialog-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid var(--color-border);
}
.faf-google-map-hint {
  font-size: 0.78rem;
  color: var(--color-text-muted);
}
.faf-google-map-canvas {
  width: 100%;
  height: min(420px, 55vh);
  background: #e2e8f0;
}
.faf-google-map-preview {
  padding: 0.75rem 1rem;
  border-top: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
  font-size: 0.9rem;
  color: var(--color-text);
  min-height: 2.75rem;
}
.faf-google-map-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.less","webpack://./src/styles/faf.less"],"names":[],"mappings":"AA6BA;;;EAGE,sBAAA;EACA,SAAA;EACA,UAAA;AA5BF;AA+BA;EACE,mBAAA;EACA,wBAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,wBAAA;EACA,8BAAA;EACA,8BAAA;EACA,wBAAA;EACA,2BAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;EACA,aAAA;EACA,iBAAA;EACA,0CAAA;EACA,oDAAA;AA7BF;AAgCA;;;EAGE,YAAA;AA9BF;AAiCA;EACE,wBAAA;EACA,2BAAA;EACA,wBAAA;EACA,gBAAA;EACA,mCAAA;AA/BF;AACA,kBAAkB;AAmClB;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gDAAA;EACA,oBAAA;AAjCF;AAoCA;EACE,aAAA;EACA,mBAAA;AAlCF;AAqCA;EACE,gCAAA;EACA,WAAA;AAnCF;AAsCA;EACE,sCAAA;AApCF;AAuCA;EACE,gCAAA;EACA,wBAAA;EACA,iCAAA;AArCF;AAwCA;EACE,2BAAA;AAtCF;AAyCA;EACE,uBAAA;EACA,8BAAA;EACA,iCAAA;AAvCF;AA0CA;EACE,2BAAA;EACA,wBAAA;AAxCF;AA2CA;EACE,WAAA;AAzCF;AACA,eAAe;AA6Cf;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,gCAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;AA3CF;AA8CA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AA5CF;AACA,gBAAgB;AAgDhB;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,oEAAA;AA9CF;AAiDA;EACE,WAAA;EACA,gBAAA;EACA,gCAAA;EACA,+BAAA;EACA,yBAAA;EACA,aAAA;AA/CF;AAkDA;EACE,kBAAA;EACA,sBAAA;AAhDF;AAmDA;EACE,mBAAA;AAjDF;AAoDA;EACE,kBAAA;EACA,gBAAA;AAlDF;AAqDA;EACE,8BAAA;EACA,iBAAA;EACA,mBAAA;AAnDF;AAsDA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AApDF;AAuDA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;AArDF;AAwDA;EACE,uBAAA;EACA,qCAAA;EACA,4BAAA;EACA,kBAAA;EACA,oBAAA;EACA,8BAAA;AAtDF;AAyDA;EACE,aAAA;EACA,kCAAA;EACA,gDAAA;AAvDF;AA0DA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,8BAAA;EACA,iBAAA;AAxDF;AA2DA;;EAEE,WAAA;EACA,OAAA;EACA,WAAA;EACA,+BAAA;AAzDF;AACA,iBAAiB;AA6DjB;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,mBAAA;AA3DF;AA8DA;EACE,iCAAA;EACA,yBAAA;EACA,yBAAA;AA5DF;AA+DA;EACE,mCAAA;EACA,2BAAA;EACA,yBAAA;AA7DF;AACA,iBAAiB;AAiEjB;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;AA/DF;AAkEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,gCAAA;EACA,4CAAA;AAhEF;AAmEA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAjEF;AAoEA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAlEF;AAqEA;EACE,kBAAA;AAnEF;AAsEA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,4BAAA;EACA,eAAA;EACA,oBAAA;AApEF;AAuEA;;EAEE,wBAAA;EACA,2BAAA;AArEF;AAwEA;EACE,kBAAA;EACA,wBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,gCAAA;EACA,qCAAA;EACA,+BAAA;EACA,6CAAA;AAtEF;AAyEA;EACE,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,sBAAA;AAvEF;AA0EA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAxEF;AA2EA;EACE,aAAA;EACA,iCAAA;EACA,WAAA;EACA,qBAAA;AAzEF;AA4EA;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;AA1EF;AA6EA;EACE,SAAA;EACA,iBAAA;EACA,wBAAA;EACA,sBAAA;AA3EF;AA8EA;EACE,SAAA;EACA,kBAAA;EACA,8BAAA;AA5EF;AA+EA;EACE,SAAA;EACA,kBAAA;EACA,cAAA;AA7EF;AAgFA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,gCAAA;EACA,4CAAA;AA9EF;AAiFA;EACE,uBAAA;EACA,4BAAA;EACA,qBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,yCAAA;AA/EF;AAkFA;EACE,2BAAA;EACA,wBAAA;AAhFF;AAmFA;EACE,2BAAA;EACA,sCAAA;AAjFF;AAoFA;EACE,mBAAA;EACA,iCAAA;AAlFF;AAqFA;EACE,OAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;AAnFF;AACA,eAAe;AAuFf;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,8BAAA;EACA,sBAAA;AArFF;AAwFA;EACE,eAAA;EACA,wBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAtFF;AAgFA;EASI,2BAAA;EACA,gBAAA;EACA,qBAAA;AAtFJ;AAwFI;EACE,0BAAA;AAtFN;AA2FA;EACE,cAAA;AAzFF;AA4FA;EACE,iBAAA;EACA,gBAAA;AA1FF;AA6FA;EACE,8BAAA;EACA,iBAAA;EACA,mBAAA;AA3FF;AA8FA;EACE,kBAAA;EACA,8BAAA;EACA,oBAAA;AA5FF;AACA,6BAA6B;AAgG7B;EACE,mBAAA;EACA,gCAAA;EACA,qCAAA;EACA,+BAAA;EACA,gBAAA;AA9FF;AAiGA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;AA/FF;AAkGA;EACE,aAAA;EACA,oCAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAhGF;AAmGA;EACE,mBAAA;AAjGF;AAoGA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;AAlGF;AAqGA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AAnGF;AAsGA;EACE,iBAAA;EACA,8BAAA;AApGF;AAuGA;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;AArGF;AAwGA;EACE,oBAAA;EACA,yCAAA;AAtGF;AAyGA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;AAvGF;AA0GA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,2BAAA;EACA,eAAA;AAxGF;AA2GA;EACE,cAAA;EACA,iBAAA;AAzGF;AA4GA;EACE,gBAAA;EACA,iBAAA;AA1GF;AA6GA;EACE,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,sBAAA;AA3GF;AA8GA;EACE,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;AA5GF;AA+GA;EACE,iBAAA;EACA,8BAAA;EACA,uBAAA;AA7GF;AAgHA;EACE,kCAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;AA9GF;AAiHA;EACE,mBAAA;EACA,mBAAA;EACA,8BAAA;AA/GF;AAkHA;EACE,kCAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AAhHF;AAmHA;EACE,aAAA;EACA,6DAAA;EACA,YAAA;EACA,kBAAA;AAjHF;AAoHA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,oCAAA;EACA,mBAAA;EACA,mBAAA;AAlHF;AAqHA;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAnHF;AAsHA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;EACA,gBAAA;AApHF;AAuHA;EACE,kBAAA;EACA,8BAAA;AArHF;AAwHA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AAtHF;AACA,kBAAkB;AA0HlB;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,aAAA;EACA,gCAAA;EACA,qCAAA;EACA,+BAAA;EACA,mBAAA;AAxHF;AA2HA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;EACA,gBAAA;AAzHF;AA4HA;;EAEE,uBAAA;EACA,qCAAA;EACA,4BAAA;EACA,iBAAA;EACA,oBAAA;EACA,gCAAA;AA1HF;AA6HA;;EAEE,aAAA;EACA,kCAAA;AA3HF;AA8HA;EACE,eAAA;EACA,gBAAA;AA5HF;AA+HA;EACE,oBAAA;EACA,kBAAA;AA7HF;AACA,gBAAgB;AAiIhB;EACE,gCAAA;EACA,qCAAA;EACA,+BAAA;EACA,gBAAA;AA/HF;AAkIA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;AAhIF;AAmIA;EACE,gBAAA;EACA,qBAAA;EACA,2BAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,yBAAA;EACA,sBAAA;EACA,4CAAA;AAjIF;AAoIA;EACE,qBAAA;EACA,4CAAA;AAlIF;AAqIA;EACE,mBAAA;AAnIF;AAsIA;EACE,mBAAA;AApIF;AAuIA;;EAEE,eAAA;AArIF;AAuIA;;EAEE,eAAA;AArIF;AAwIA;;EAEE,gBAAA;EACA,mBAAA;AAtIF;AAyIA;;EAEE,eAAA;AAvIF;AA0IA;;EAEE,eAAA;AAxIF;AA2IA;EACE,mDAAA;EACA,kBAAA;AAzIF;AA4IA;EACE,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,gCAAA;EACA,qCAAA;EACA,+BAAA;AA1IF;AA6IA;EACE,8BAAA;AA3IF;AA8IA;EACE,2BAAA;EACA,gBAAA;EACA,qBAAA;AA5IF;AA+IA;EACE,0BAAA;AA7IF;AACA,kEAAkE;AAgJlE;EACE,aAAA;AA9IF;AAiJA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AA/IF;AAkJA;EACE,uBAAA;EACA,qCAAA;EACA,oCAAA;EACA,gCAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;AAhJF;AAmJA;EACE,kCAAA;EACA,mBAAA;EACA,2BAAA;AAjJF;AAoJA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAlJF;AAqJA;EACE,gCAAA;EACA,qCAAA;EACA,+BAAA;EACA,oBAAA;AAnJF;AAsJA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AApJF;AAuJA;EACE,eAAA;AArJF;AAwJA;EACE,aAAA;EACA,eAAA;EACA,oBAAA;EACA,SAAA;AAtJF;AAkJA;EAOI,gBAAA;EACA,YAAA;AAtJJ;AA8IA;EAYI,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;AAvJJ;AAsIA;EAqBI,SAAA;EACA,mBAAA;EACA,wBAAA;EACA,uBAAA;AAxJJ;AACA,0BAA0B;AA6J1B;EACE,qBAAA;EACA,qBAAA;EACA,8BAAA;EACA,qBAAA;EACA,kBAAA;AA3JF;AA8JA;EACE,2BAAA;AA5JF;AA+JA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA7JF;AAgKA;EACE,gCAAA;EACA,qCAAA;EACA,+BAAA;EACA,uBAAA;AA9JF;AAiKA;EACE,gBAAA;EACA,kBAAA;AA/JF;AAkKA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAhKF;AAmKA;EACE,qBAAA;EACA,qCAAA;EACA,kBAAA;EACA,mBAAA;AAjKF;AAoKA;EACE,SAAA;AAlKF;AAqKA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;AAnKF;AA6JA;EASI,SAAA;AAnKJ;AAuKA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AArKF;AAwKA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAtKF;AAyKA;EAk7DE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AAxlEF;AA0lEE;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,qBAAA;AAxlEJ;AA2lEE;EACE,aAAA;EACA,8CAAA;AAzlEJ;AA4lEE;EACE,YAAA;EACA,mBAAA;AA1lEJ;AA8IA;EACE,mBAAA;EACA,oCAAA;EACA,kBAAA;AA5IF;AA+IA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,SAAA;AA7IF;AAgJA;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,qBAAA;AA9IF;AAiJA;EACE,SAAA;EACA,iBAAA;AA/IF;AAkJA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;AAhJF;AAmJA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;EACA,qCAAA;EACA,oBAAA;EACA,oCAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AAjJF;AAoJA;EACE,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,8CAAA;AAlJF;AAqJA;EACE,kCAAA;EACA,mBAAA;AAnJF;AAsJA;EACE,mBAAA;AApJF;AAuJA;EACE,gBAAA;EACA,wBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AArJF;AAwJA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,kCAAA;AAtJF;AAyJA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAvJF;AA0JA;EACE,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,0CAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;AAxJF;AA2JA;EACE,oCAAA;EACA,qBAAA;EACA,qCAAA;EACA,2CAAA;EACA,oCAAA;EACA,oCAAA;EACA,iFAAA;AAzJF;AA4JA;EACE,wBAAA;AA1JF;AA6JA;EACE,wBAAA;AA3JF;AA8JA;EACE,wBAAA;AA5JF;AA+JA;EACE,wBAAA;AA7JF;AAgKA;EACE,wBAAA;AA9JF;AAiKA;EACE,wBAAA;AA/JF;AAkKA;EACE,mBAAA;EACA,gBAAA;AAhKF;AAmKA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,8BAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,8BAAA;AAjKF;AAyJA;EAWI,gBAAA;EACA,wBAAA;AAjKJ;AAqKA;EACE,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AAnKF;AAsKA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qCAAA;EACA,oCAAA;EACA,oDAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AApKF;AAuKA;EACE,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AArKF;AAwKA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,yCAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAtKF;AA0KE;EACE,cAAA;EACA,gBAAA;EACA,8BAAA;AAxKJ;AA4KA;EACE,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,wBAAA;EACA,qBAAA;EACA,uBAAA;AA1KF;AA6KA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,yCAAA;AA3KF;AA8KA;EA0sDE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AAr3DF;AAu3DE;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,qBAAA;AAr3DJ;AAw3DE;EACE,aAAA;EACA,8CAAA;AAt3DJ;AAy3DE;EACE,YAAA;EACA,mBAAA;AAv3DJ;AACA,qBAAqB;AAoJrB;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AAlJF;AAqJA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,qCAAA;EACA,+BAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iEAAA;AAnJF;AAsJA;EACE,kCAAA;EACA,0CAAA;AApJF;AAuJA;EACE,0BAAA;AArJF;AAwJA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,4BAAA;EACA,sCAAA;EACA,2BAAA;AAtJF;AAyJA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AAvJF;AA0JA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;AAxJF;AA2JA;EACE,iBAAA;EACA,8BAAA;AAzJF;AA4JA;EACE,kBAAA;EACA,8BAAA;AA1JF;AACA,6BAA6B;AA8J7B;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AA5JF;AA+JA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,wBAAA;EACA,qCAAA;EACA,oCAAA;EACA,oCAAA;AA7JF;AAgKA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iCAAA;EACA,+CAAA;EACA,2BAAA;AA9JF;AAiKA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;AA/JF;AAkKA;EACE,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,sBAAA;AAhKF;AAmKA;EACE,2BAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AAjKF;AAoKA;EACE,0BAAA;AAlKF;AAqKA;EACE,YAAA;EACA,YAAA;AAnKF;AAsKA;EA6jDE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EAzkDA,sBAAA;EACA,mBAAA;AAtJF;AAguDE;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,qBAAA;AA9tDJ;AAiuDE;EACE,aAAA;EACA,8CAAA;AA/tDJ;AAkuDE;EACE,YAAA;EACA,mBAAA;AAhuDJ;AA2IA;EACE,YAAA;EACA,YAAA;AAzIF;AA4IA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;AA1IF;AA6IA;EACE,kBAAA;EACA,8BAAA;AA3IF;AA8IA;EACE,mBAAA;AA5IF;AACA,qBAAqB;AAgJrB;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kCAAA;EACA,gBAAA;AA9IF;AAiJA;EACE,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,+BAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AA/IF;AAkJA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;EACA,4CAAA;EACA,gCAAA;EACA,oDAAA;AAhJF;AAmJA;EACE,SAAA;EACA,kBAAA;AAjJF;AAoJA;EACE,iBAAA;EACA,8BAAA;AAlJF;AAqJA;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,4BAAA;EACA,eAAA;EACA,8BAAA;AAnJF;AAsJA;EACE,2BAAA;EACA,wBAAA;AApJF;AAuJA;EACE,YAAA;EACA,mBAAA;AArJF;AAwJA;EACE,gBAAA;EACA,yBAAA;AAtJF;AACA,qBAAqB;AA0JrB;EACE,aAAA;EACA,mCAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAxJF;AA2JA;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;AAzJF;AA4JA;EACE,cAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AA1JF;AA6JA;EACE,kBAAA;EACA,8BAAA;AA3JF;AA8JA;EACE,YAAA;EACA,mBAAA;AA5JF;AA+JA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AA7JF;AAgKA;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,qCAAA;EACA,sCAAA;EACA,4BAAA;EACA,kBAAA;EACA,iCAAA;EACA,eAAA;AA9JF;AAiKA;EACE,2BAAA;AA/JF;AAkKA;EACE,gCAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;AAhKF;AAmKA;EACE,YAAA;EACA,mBAAA;AAjKF;AAoKA;EACE,kBAAA;EACA,8BAAA;AAlKF;AAqKA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;AAnKF;AAsKA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qCAAA;EACA,4BAAA;EACA,kBAAA;AApKF;AACA,4BAA4B;AAuK5B;EACE,UAAA;AArKF;AAwKA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,yBAAA;EACA,sBAAA;AAtKF;AAyKA;EACE,iCAAA;AAvKF;AA0KA;EACE,2BAAA;AAxKF;AA2KA;EACE,iBAAA;EACA,YAAA;AAzKF;AA4KA;EACE,UAAA;AA1KF;AACA,iBAAiB;AA8KjB;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,wCAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AA5KF;AA+KA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;AA7KF;AAgLA;EACE,mBAAA;EACA,cAAA;AA9KF;AAiLA;EACE,mBAAA;EACA,cAAA;AA/KF;AAkLA;EACE,mBAAA;EACA,cAAA;AAhLF;AAmLA;;EAEE,mBAAA;EACA,cAAA;AAjLF;AAoLA;EACE,mBAAA;EACA,cAAA;AAlLF;AAqLA;EACE,qBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AAnLF;AAsLA;EACE,sCAAA;EACA,2BAAA;AApLF;AAuLA;EACE,mBAAA;EACA,2BAAA;AArLF;AAwLA;EACE,mCAAA;EACA,2BAAA;AAtLF;AAyLA;EACE,mBAAA;EACA,WAAA;AAvLF;AACA,eAAe;AA2Lf;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,4CAAA;AAzLF;AA4LA;EACE,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;EACA,eAAA;EACA,oCAAA;EACA,mBAAA;EACA,uBAAA;AA1LF;AA6LA;EACE,wBAAA;AA3LF;AA8LA;EACE,2BAAA;EACA,yCAAA;AA5LF;AACA,4DAA4D;AAgM5D;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;AA9LF;AAiMA;EACE,oBAAA;EACA,oBAAA;EACA,eAAA;EACA,qCAAA;EACA,oBAAA;EACA,sCAAA;EACA,gBAAA;AA/LF;AAkMA;EACE,kCAAA;EACA,mBAAA;AAhMF;AAmMA;EACE,uBAAA;EACA,qCAAA;EACA,oBAAA;EACA,sCAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,eAAA;EACA,6DAAA;AAjMF;AAoMA;EACE,SAAA;EACA,gBAAA;EACA,uBAAA;AAlMF;AAqMA;EACE,2BAAA;AAnMF;AAsMA;EACE,wBAAA;EACA,qCAAA;AApMF;AAuMA;EACE,2BAAA;EACA,kCAAA;EACA,mBAAA;AArMF;AAwMA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,4BAAA;EACA,SAAA;EACA,uBAAA;EACA,8BAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAtMF;AAyMA;EACE,kCAAA;AAvMF;AA0MA;EACE,oBAAA;AAxMF;AA2MA;;EAEE,2BAAA;EACA,kCAAA;AAzMF;AA4MA;EACE,kBAAA;AA1MF;AA6MA;EACE,kBAAA;EACA,wBAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,qCAAA;EACA,qCAAA;EACA,sCAAA;EACA,yBAAA;AA3MF;AA8MA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;EACA,iCAAA;EACA,uBAAA;EACA,wBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AA5MF;AA+MA;EACE,mBAAA;EACA,2BAAA;AA7MF;AACA,wDAAwD;AAgNxD;EAEI,gBAAA;EACA,MAAA;EACA,WAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;EACA,4CAAA;EACA,mDAAA;AA/MJ;AAsMA;EAaI,aAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,sBAAA;AAhNJ;AA+LA;EAoBM,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAhNN;AAyLA;EA2BM,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;AAjNN;AAmLA;EAmCI,qBAAA;AAnNJ;AAgLA;EAuCI,uBAAA;EACA,kBAAA;AApNJ;AA4KA;EA4CI,SAAA;EACA,YAAA;AArNJ;AAwKA;EAiDI,oBAAA;EACA,MAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;AAtNJ;AA8JA;EA2DM,SAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAtNN;AAwNM;EACE,cAAA;EACA,mBAAA;AAtNR;AAiJA;EA2EI,aAAA;EACA,2CAAA;EACA,SAAA;EACA,kBAAA;AAzNJ;AA2NI;EACE,qCAAA;AAzNN;AAwIA;EAsFI,YAAA;AA3NJ;AAqIA;EA0FI,eAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,+CAAA;EACA,eAAA;AA5NJ;AA8NI;EACE,mBAAA;AA5NN;AAkHA;EA+GI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;AA9NJ;AA2GA;EAuHI,OAAA;EACA,YAAA;AA/NJ;AAuGA;EA4HI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAhOJ;AAyFA;EA2II,oBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAjOJ;AA4EA;EAyJI,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlOJ;AAuEA;;EAgKI,mBAAA;EACA,WAAA;AAnOJ;AAkEA;EAqKI,cAAA;EACA,gBAAA;AApOJ;AA8DA;EA0KI,kCAAA;EACA,uBAAA;AArOJ;AA0DA;EA+KI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,2EAAA;AAtOJ;AA8CA;EA4LI,cAAA;EACA,kBAAA;AAvOJ;AA0CA;EAiMI,aAAA;EACA,WAAA;AAxOJ;AAsCA;EAsMI,aAAA;AAzOJ;AAmCA;EA0MI,aAAA;EACA,eAAA;EACA,YAAA;AA1OJ;AA8BA;EAgNI,eAAA;EACA,SAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AA3OJ;AAsBA;EAyNI,qBAAA;EACA,mBAAA;EACA,6BAAA;AA5OJ;AAiBA;EA+NI,sBAAA;EACA,kBAAA;EACA,iBAAA;AA7OJ;AAYA;EAqOI,sBAAA;EACA,kBAAA;AA9OJ;AAQA;EA0OI,kBAAA;EACA,kBAAA;AA/OJ;AAIA;EA+OI,iBAAA;AAhPJ;AAoPA;EACE;IACE,0BAAA;EAlPF;EAqPA;IACE,gBAAA;IACA,cAAA;IACA,gBAAA;EAnPF;AACF;AAsPA;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;AApPF;AAuPA;EACE,mBAAA;AArPF;AACA,6BAA6B;AAyP7B;EACE,gCAAA;EACA,qCAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;AAvPF;AA0PA;EACE,6CAAA;EACA,wDAAA;EACA,6CAAA;EACA,yCAAA;AAxPF;AA2PA;;;EAII,oBAAA;EACA,sBAAA;EACA,+BAAA;EACA,+BAAA;AA1PJ;AAmPA;;;;;;;;;;;;;;;EAeI,eAAA;EACA,WAAA;AAjPJ;AAiOA;;;;;;;;;EAsBI,mBAAA;EACA,sBAAA;AA5OJ;AAqNA;;;EA2BI,qBAAA;AA3OJ;AAgNA;;;EA+BI,mBAAA;AA1OJ;AA2MA;;;;;;EAoCI,sBAAA;AAvOJ;AA2OA;EACE,kBAAA;EACA,QAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,+BAAA;AAzOF;AACA,wEAAwE;AA4OxE;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,gBAAA;EACA,kCAAA;AA1OF;AA6OA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,qCAAA;EACA,6CAAA;EACA,wBAAA;EACA,kBAAA;AA3OF;AA8OA;EACE,WAAA;EACA,YAAA;AA5OF;AACA,iBAAiB;AAgPjB;EACE,gCAAA;EACA,qCAAA;EACA,+BAAA;EACA,aAAA;AA9OF;AAiPA;EACE,gBAAA;EACA,mBAAA;EACA,uCAAA;AA/OF;AAkPA;EACE,oBAAA;AAhPF;AAmPA;EACE,aAAA;AAjPF;AAoPA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,sCAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gDAAA;AAlPF;AAqPA;EACE,kCAAA;EACA,sCAAA;AAnPF;AAsPA;EACE,eAAA;AApPF;AAuPA;EACE,kBAAA;EACA,8BAAA;AArPF;AAwPA;EACE,aAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;AAtPF;AACA,kBAAkB;AA0PlB;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,8BAAA;AAxPF;AA2PA;EACE,WAAA;EACA,YAAA;EACA,qCAAA;EACA,sCAAA;EACA,kBAAA;EACA,oCAAA;AAzPF;AA4PA;EACE;IACE,yBAAA;EA1PF;AACF;AACA,qBAAqB;AA8PrB;EACE;IACE,aAAA;EA5PF;EA+PA;IACE,sBAAA;IACA,oBAAA;EA7PF;EAgQA;IACE,gBAAA;EA9PF;EAiQA;IACE,aAAA;EA/PF;EAkQA;IACE,cAAA;EAhQF;EAmQA;IACE,sBAAA;IACA,WAAA;EAjQF;AACF;AACA,sCAAsC;AAqQtC;EACE,mBAAA;EACA,eAAA;AAnQF;AA2QE;;;;;EACE,2CAAA;EACA,mBAAA;AArQJ;AAyQA;EACE,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kGAAA;AAvQF;AA6QE;EACE,0BAAA;AA3QJ;AA+QA;EACE,mBAAA;EACA,8CAAA;AA7QF;AAgRA;EACE,cAAA;EACA,qBAAA;AA9QF;AAiRA;EACE,cAAA;EACA,mBAAA;AA/QF;AACA,UAAU;AAmRV;EACE,aAAA;EACA,0DAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AAjRF;AAoRA;EACE,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,8BAAA;EACA,gBAAA;EACA,+BAAA;EACA,WAAA;EACA,mBAAA;AAlRF;AAoRE;EACE,kBAAA;EACA,QAAA;EACA,yJAAA;EAGA,0BAAA;EACA,WAAA;EACA,qEAAA;EACA,6DAAA;AApRJ;AAgQA;EAwBI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,sBAAA;AArRJ;AAyRA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;AAvRF;AA0RA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,oDAAA;AAxRF;AA2RA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,2CAAA;AAzRF;AA4RA;EACE,WAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AA1RF;AA6RA;EACE,mBAAA;EACA,kBAAA;AA3RF;AAyRA;EAKI,kBAAA;EACA,cAAA;EACA,uCAAA;EACA,gBAAA;EACA,wBAAA;AA3RJ;AAkRA;EAaI,kBAAA;EACA,cAAA;AA5RJ;AAgSA;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;AA9RF;AAiSA;EACE,YAAA;AA/RF;AA8RA;EAII,YAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AA/RJ;AAwRA;EAWI,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AAhSJ;AAkSI;EAt3EF,aAAA;EACA,qBAAA;EACA,8CAAA;AAulEF;AA4QA;EAuBI,gBAAA;EACA,mBAAA;AAhSJ;AAoSA;EACE,gBAAA;AAlSF;AAqSA;EACE,kBAAA;EACA,+BAAA;EACA,cAAA;EACA,8BAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAnSF;AA4RA;EAUI,cAAA;EACA,gBAAA;EACA,qBAAA;AAnSJ;AAqSI;EACE,0BAAA;AAnSN;AACA,iBAAiB;AAySjB;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,gCAAA;EACA,6DAAA;AAvSF;AA0SA;;EAEE,aAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;AAxSF;AA2SA;EACE,kBAAA;EACA,gBAAA;AAzSF;AA4SA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;AA1SF;AA6SA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EA3SA,6DAA6D;EA6S7D,6HAAA;AA3SF;AA+SA;EACE,kBAAA;EACA,SAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;AA7SF;AAgTA;EACE,UAAA;EACA,YAAA;EACA,sBAAA;EACA,kCAAA;AA9SF;AAiTA;EACE,gBAAA;AA/SF;AAkTA;EACE,YAAA;EACA,UAAA;AAhTF;AAmTA;EACE,6BAAA;EACA,oBAAA;AAjTF;AAmTE;;EAEE,cAAA;EACA,kCAAA;AAjTJ;AAqTA;EACE,gBAAA;EACA,uBAAA;EACA,wCAAA;EACA,cAAA;EACA,uBAAA;AAnTF;AAqTE;EACE,qBAAA;EACA,kCAAA;AAnTJ;AAuTA;EArgFE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4CAAA;EAogFA,yBAAA;AAlTF;AAqTA;EACE,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,4BAAA;AAnTF;AAsTA;EACE,gBAAA;AApTF;AAuTA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AArTF;AAwTA;EACE,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAtTF;AAwTE;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;EACA,uBAAA;EACA,WAAA;AAtTJ;AAyTE;EACE,cAAA;EACA,uBAAA;AAvTJ;AA0TE;EACE,cAAA;AAxTJ;AA0TI;EACE,mBAAA;AAxTN;AA6TA;EACE,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;EACA,mBAAA;EACA,6CAAA;AA3TF;AA6TE;EACE,aAAA;AA3TJ;AA8TE;EACE,WAAA;EACA,mBAAA;AA5TJ;AAgUA;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AA9TF;AAiUA;EACE,iBAAA;EACA,oCAAA;AA/TF;AAkUA;EACE,WAAA;EACA,gBAAA;EACA,UAAA;EACA,6BAAA;EACA,cAAA;EACA,mBAAA;AAhUF;AAmUA;EACE,WAAA;EAEA,cAAA;EACA,kBAAA;AAlUF;AA8TA;EAOI,SAAA;EACA,kBAAA;EACA,iBAAA;AAlUJ;AAyTA;EAaI,cAAA;EACA,gBAAA;EACA,qBAAA;AAnUJ;AAqUI;EACE,0BAAA;AAnUN;AAwUA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,yCAAA;EACA,mBAAA;EACA,gCAAA;AAtUF;AAyUA;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;AAvUF;AA0UA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAxUF;AA2UA;EACE,iBAAA;EACA,gCAAA;EACA,0BAAA;EACA,4BAAA;AAzUF;AACA,8BAA8B;AA6U9B;EACE,qBAAA;EACA,mBAAA;AA3UF;AAyUA;EAKI,cAAA;EACA,sCAAA;EACA,gBAAA;EACA,wBAAA;AA3UJ;AA+UA;EACE,kBAAA;EACA,cAAA;AA7UF;AAgVA;EACE,wBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AA9UF;AAiVA;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6CAAA;AA/UF;AAkVA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,8BAAA;EACA,wBAAA;EACA,SAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAhVF;AAkVE;EACE,mBAAA;AAhVJ;AAoVA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;AAlVF;AAqVA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;AAnVF;AAsVA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AApVF;AAuVA;EACE,uBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AArVF;AAwVA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,gCAAA;AAtVF;AAyVA;EACE,yBAAA;AAvVF;AA0VA;EACE,SAAA;EACA,6BAAA;EACA,SAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;AAxVF;AAkVA;EASI,cAAA;EACA,kBAAA;EACA,gBAAA;AAxVJ;AA6UA;;EAeM,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AAxVN;AA0VM;;EAtxFJ,aAAA;EACA,qBAAA;EACA,8CAAA;AAg8EF;AA2VA;EACE,aAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAzVF;AAkVA;EAUI,eAAA;AAzVJ;AA6VA;EACE,qBAAA;EACA,6BAAA;EACA,mBAAA;EACA,4CAAA;AA3VF;AA8VA;EACE,kBAAA;AA5VF;AA2VA;EAII,mBAAA;EACA,qBAAA;AA5VJ;AAuVA;EASI,oBAAA;EACA,qBAAA;EACA,cAAA;AA7VJ;AAkVA;EAeI,iCAAA;AA9VJ;AAgWI;EACE,mBAAA;AA9VN;AAmWA;EACE,cAAA;EACA,kBAAA;EACA,uBAAA;AAjWF;AAoWA;EACE,cAAA;AAlWF;AAqWA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AAnWF;AAyYA;EAlCE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AApWF;AAsWE;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,qBAAA;AApWJ;AAuWE;EACE,aAAA;EACA,8CAAA;AArWJ;AAwWE;EACE,YAAA;EACA,mBAAA;AAtWJ;AA8WA;EACE,gBAAA;EACA,gBAAA;AA5WF;AA+WA;EACE,+BAAA;AA7WF;AAgXA;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;AA9WF;AAiXA;EACE,cAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;EACA,qCAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sCAAA;EACA,wBAAA;AA/WF;AAkXA;EACE,uCAAA;EACA,mBAAA;AAhXF;AAmXA;EACE,aAAA;EACA,yBAAA;EACA,WAAA;AAjXF;AAoXA;EACE,WAAA;EACA,mBAAA;AAlXF;AAqXA;EACE,WAAA;EACA,mBAAA;AAnXF;AAsXA;EACE,WAAA;EACA,mBAAA;AApXF;AAuXA;EACE,WAAA;EACA,mBAAA;AArXF;AAwXA;EACE,mBAAA;EACA,cAAA;AAtXF;AAyXA;EACE,mBAAA;EACA,cAAA;AAvXF;AA0XA;EACE,mBAAA;EACA,cAAA;AAxXF;AA2XA;EACE,mBAAA;EACA,cAAA;AAzXF;AA4XA;EACE,mBAAA;EACA,cAAA;AA1XF;AA6XA;EACE,mBAAA;EACA,cAAA;AA3XF;AA8XA;EACE,mBAAA;EACA,cAAA;AA5XF;AA+XA;;EAEE,mBAAA;EACA,cAAA;AA7XF;AAgYA;EACE,mBAAA;EACA,cAAA;AA9XF;AAiYA;EACE,mBAAA;EACA,uBAAA;AA/XF;AAkYA;EACE,YAAA;AAhYF;AAmYA;EACE,kBAAA;AAjYF;AAmYE;EACE,mBAAA;EACA,qBAAA;AAjYJ;AAsYE;EAlgGA,aAAA;EACA,qBAAA;EACA,8CAAA;AA+nFF;AACA,uCAAuC;AAuYvC;EACE,cAAA;EACA,gBAAA;AArYF;AAwYA;EACE,SAAA;AAtYF;AAyYA;EAzhGE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4CAAA;EAwhGA,uBAAA;AApYF;AAkYA;EAKI,sBAAA;EACA,gCAAA;EACA,cAAA;EACA,eAAA;AApYJ;AAwYA;EACE,mBAAA;AAtYF;AAqYA;EAII,cAAA;EACA,iBAAA;EACA,gBAAA;AAtYJ;AAgYA;EAUI,cAAA;EACA,gBAAA;AAvYJ;AA2YA;EACE,qBAAA;EACA,4CAAA;AAzYF;AA2YE;EACE,qBAAA;EACA,+CAAA;AAzYJ;AA6YA;EACE,cAAA;EACA,mBAAA;AA3YF;AA8YA;EACE,qBAAA;AA5YF;AA+YA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AA7YF;AA+YE;EACE,cAAA;EACA,4BAAA;AA7YJ;AAiZA;;EAllGE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4CAAA;AAqsFF;AA+YA;;;EAGE,gCAAA;EACA,qCAAA;EACA,sCAAA;EACA,gCAAA;EACA,gCAAA;EACA,6BAAA;EACA,8BAAA;EACA,oBAAA;EACA,sBAAA;EACA,+BAAA;EACA,+BAAA;AA7YF;AAgZA;EACE,qBAAA;EACA,mBAAA;AA9YF;AAgZE;EACE,qBAAA;EACA,mBAAA;AA9YJ;AAkZA;EACE,kBAAA;EACA,4CAAA;AAhZF;AAmZA;;EAEE,qBAAA;EACA,mBAAA;EACA,4CAAA;AAjZF;AAoZA;EACE,iCAAA;EACA,kCAAA;EACA,0BAAA;AAlZF;AAqZA;EACE,2CAAA;EACA,6CAAA;AAnZF;AAsZA;EACE,cAAA;EACA,mBAAA;AApZF;AAuZA;EACE;IACE,aAAA;EArZF;EAwZA;;IAEE,aAAA;EAtZF;EAyZA;IACE,0BAAA;IACA,qBAAA;EAvZF;EA0ZA;;IAEE,cAAA;EAxZF;EA2ZA;IACE,WAAA;IACA,uBAAA;IACA,eAAA;EAzZF;AACF;AA4ZA;EACE;IACE,cAAA;EA1ZF;EA6ZA;IACE,iBAAA;IACA,eAAA;EA3ZF;EA8ZA;IACE,+BAAA;IACA,+BAAA;EA5ZF;EA+ZA;IACE,cAAA;IACA,aAAA;EA7ZF;EAgaA;IACE,gBAAA;EA9ZF;EAiaA;IACE,YAAA;EA/ZF;EAkaA;IACE,YAAA;IACA,WAAA;EAhaF;EAmaA;IACE,iBAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;EAjaF;EAoaA;IACE,qBAAA;IACA,gBAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;EAlaF;EAqaA;IACE,uBAAA;EAnaF;EAsaA;IACE,uBAAA;EApaF;EAuaA;IACE,0BAAA;EAraF;EAwaA;IACE,sBAAA;EAtaF;EAyaA;IACE,SAAA;IACA,gBAAA;EAvaF;EA0aA;IACE,WAAA;IACA,yBAAA;IACA,cAAA;EAxaF;EA2aA;IACE,6BAAA;IACA,mBAAA;EAzaF;EA4aA;IACE,qBAAA;IACA,4CAAA;EA1aF;EA6aA;IACE,qBAAA;EA3aF;EA8aA;IACE,aAAA;EA5aF;EA+aA;IACE,gDAAA;EA7aF;EAgbA;IACE,UAAA;EA9aF;EAibA;IACE,iBAAA;IACA,gBAAA;IACA,gBAAA;EA/aF;AACF;AAkbA;EACE;IACE,YAAA;EAhbF;EAmbA;;IAEE,aAAA;EAjbF;EAobA;IACE,YAAA;IACA,WAAA;EAlbF;EAqbA;IACE,uBAAA;EAnbF;EAsbA;IACE,eAAA;EApbF;EAubA;IACE,sBAAA;EArbF;EAwbA;IACE,aAAA;EAtbF;EAybA;IACE,0BAAA;EAvbF;AACF;AA0bA;EACE;IACE,sBAAA;EAxbF;EA2bA;IACE,sBAAA;EAzbF;EAwbA;IAII,kBAAA;EAzbJ;EA6bA;IACE,WAAA;IACA,YAAA;EA3bF;EA8bA;IACE,YAAA;EA5bF;EA+bA;IACE,oBAAA;EA7bF;EAgcA;IACE,eAAA;EA9bF;AACF;AAicA;EACE,yCAAA;EACA,kCAAA;EACA,yBAAA;EACA,gBAAA;AA/bF;AA2bA;EAOI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;AA/bJ;AAobA;;EAgBI,SAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAhcJ;AAocA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAlcF;AAqcA;EACE,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;AAncF;AACA,yDAAyD;ACh9FzD;EACE,WAAA;ADk9FF;AC/8FA;EACE,aAAA;EACA,WAAA;EACA,oBAAA;ADi9FF;AC98FA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,wBAAA;EACA,qCAAA;EACA,oCAAA;EACA,sCAAA;EACA,wBAAA;EACA,aAAA;ADg9FF;AC98FE;EACE,kCAAA;EACA,2CAAA;EACA,mBAAA;ADg9FJ;AC58FA;EACE,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,qCAAA;EACA,oCAAA;EACA,mBAAA;EACA,wBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AD88FF;AC58FE;EACE,kCAAA;EACA,mBAAA;AD88FJ;AC18FA;EACE,qBAAA;AD48FF;ACz8FA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;EACA,yBAAA;EACA,wBAAA;EACA,yBAAA;EACA,oCAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AD28FF;ACx8FA;EACE,cAAA;EACA,qBAAA;EACA,sBAAA;AD08FF;ACv8FA;EACE,cAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;ADy8FF;ACv8FE;EACE,UAAA;ADy8FJ;ACr8FA;EACE,eAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kCAAA;ADu8FF;ACp8FA;EACE,uBAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;EACA,sCAAA;EACA,8CAAA;ADs8FF;ACn8FA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,YAAA;EACA,qBAAA;EACA,4CAAA;ADq8FF;ACl8FA;EACE,kBAAA;EACA,8BAAA;ADo8FF;ACj8FA;EACE,WAAA;EACA,wBAAA;EACA,mBAAA;ADm8FF;ACh8FA;EACE,qBAAA;EACA,yCAAA;EACA,4CAAA;EACA,iBAAA;EACA,wBAAA;EACA,mBAAA;ADk8FF;AC/7FA;EACE,aAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;ADi8FF","sourcesContent":["@navy: #07337f;\n@navy-deep: #052862;\n@primary: #2379f4;\n@primary-hover: #1267dc;\n@sky: #edf7ff;\n@surface: #ffffff;\n@border: #d9e5f2;\n@text: #1d2b3c;\n@muted: #68788e;\n@success: #16833b;\n@danger: #e43045;\n@warning: #f1a62a;\n@radius: 6px;\n@radius-lg: 10px;\n@shadow: 0 8px 28px fade(@navy-deep, 8%);\n\n.surface-card() {\n  background: @surface;\n  border: 1px solid @border;\n  border-radius: @radius-lg;\n  box-shadow: @shadow;\n}\n\n.focus-ring() {\n  outline: none;\n  border-color: @primary;\n  box-shadow: 0 0 0 3px fade(@primary, 16%);\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n:root {\n  --color-bg: @sky;\n  --color-surface: @surface;\n  --color-border: @border;\n  --color-text: @text;\n  --color-text-muted: @muted;\n  --color-primary: @primary;\n  --color-primary-hover: @primary-hover;\n  --color-primary-light: #e8f2ff;\n  --color-success: @success;\n  --color-success-bg: #e7f6eb;\n  --color-error: @danger;\n  --color-error-bg: #fff0f2;\n  --color-warning: @warning;\n  --radius: @radius;\n  --radius-lg: @radius-lg;\n  --shadow: @shadow;\n  --font: Inter, 'Segoe UI', Roboto, Arial, sans-serif;\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n}\n\nbody {\n  font-family: var(--font);\n  background: var(--color-bg);\n  color: var(--color-text);\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n}\n\n/* ── Buttons ── */\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  padding: 0.55rem 1.1rem;\n  border: 1px solid transparent;\n  border-radius: var(--radius);\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n  font-family: inherit;\n}\n\n.btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background: var(--color-primary);\n  color: #fff;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: var(--color-primary-hover);\n}\n\n.btn-secondary {\n  background: var(--color-surface);\n  color: var(--color-text);\n  border-color: var(--color-border);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: var(--color-bg);\n}\n\n.btn-ghost {\n  background: transparent;\n  color: var(--color-text-muted);\n  border-color: var(--color-border);\n}\n\n.btn-ghost:hover:not(:disabled) {\n  background: var(--color-bg);\n  color: var(--color-text);\n}\n\n.btn-full {\n  width: 100%;\n}\n\n/* ── Logo ── */\n\n.logo-mark {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius);\n  background: var(--color-primary);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 0.85rem;\n  letter-spacing: 0.02em;\n  flex-shrink: 0;\n}\n\n.logo-mark.sm {\n  width: 32px;\n  height: 32px;\n  font-size: 0.75rem;\n}\n\n/* ── Login ── */\n\n.login-page {\n  min-height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  background: linear-gradient(160deg, #e8f1f8 0%, var(--color-bg) 50%);\n}\n\n.login-card {\n  width: 100%;\n  max-width: 400px;\n  background: var(--color-surface);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow);\n  padding: 2rem;\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 1.75rem;\n}\n\n.login-header .logo-mark {\n  margin: 0 auto 1rem;\n}\n\n.login-header h1 {\n  font-size: 1.35rem;\n  font-weight: 600;\n}\n\n.login-header p {\n  color: var(--color-text-muted);\n  font-size: 0.9rem;\n  margin-top: 0.25rem;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.login-form label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--color-text-muted);\n}\n\n.login-form input {\n  padding: 0.6rem 0.75rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  font-size: 0.95rem;\n  font-family: inherit;\n  transition: border-color 0.15s;\n}\n\n.login-form input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px var(--color-primary-light);\n}\n\n.login-divider {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin: 1.25rem 0;\n  color: var(--color-text-muted);\n  font-size: 0.8rem;\n}\n\n.login-divider::before,\n.login-divider::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: var(--color-border);\n}\n\n/* ── Alerts ── */\n\n.alert {\n  padding: 0.75rem 1rem;\n  border-radius: var(--radius);\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n}\n\n.alert-error {\n  background: var(--color-error-bg);\n  color: var(--color-error);\n  border: 1px solid #f5c6c2;\n}\n\n.alert-success {\n  background: var(--color-success-bg);\n  color: var(--color-success);\n  border: 1px solid #b8dfc9;\n}\n\n/* ── Layout ── */\n\n.app-layout {\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.app-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 1.5rem;\n  background: var(--color-surface);\n  border-bottom: 1px solid var(--color-border);\n}\n\n.header-brand {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-weight: 600;\n  font-size: 1rem;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.user-menu {\n  position: relative;\n}\n\n.user-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  font-size: 0.85rem;\n  color: var(--color-text-muted);\n  background: none;\n  border: none;\n  padding: 0.25rem 0.4rem;\n  border-radius: var(--radius);\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.user-label:hover,\n.user-label.is-open {\n  color: var(--color-text);\n  background: var(--color-bg);\n}\n\n.user-menu-panel {\n  position: absolute;\n  top: calc(100% + 0.4rem);\n  right: 0;\n  z-index: 40;\n  min-width: 240px;\n  padding: 0.85rem 1rem;\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);\n}\n\n.user-menu-title {\n  margin: 0 0 0.65rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.user-menu-details {\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.user-menu-details > div {\n  display: grid;\n  grid-template-columns: 4.5rem 1fr;\n  gap: 0.5rem;\n  align-items: baseline;\n}\n\n.user-menu-details dt {\n  margin: 0;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--color-text-muted);\n}\n\n.user-menu-details dd {\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--color-text);\n  word-break: break-word;\n}\n\n.user-menu-muted {\n  margin: 0;\n  font-size: 0.85rem;\n  color: var(--color-text-muted);\n}\n\n.user-menu-error {\n  margin: 0;\n  font-size: 0.85rem;\n  color: #b91c1c;\n}\n\n.app-nav {\n  display: flex;\n  gap: 0.25rem;\n  padding: 0.5rem 1.5rem;\n  background: var(--color-surface);\n  border-bottom: 1px solid var(--color-border);\n}\n\n.nav-link {\n  padding: 0.45rem 0.9rem;\n  border-radius: var(--radius);\n  text-decoration: none;\n  color: var(--color-text-muted);\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: background 0.15s, color 0.15s;\n}\n\n.nav-link:hover {\n  background: var(--color-bg);\n  color: var(--color-text);\n}\n\n.nav-link-primary {\n  color: var(--color-primary);\n  background: var(--color-primary-light);\n}\n\n.nav-link-primary:hover {\n  background: #d4e6f3;\n  color: var(--color-primary-hover);\n}\n\n.app-main {\n  flex: 1;\n  padding: 1.5rem;\n  max-width: 1200px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n/* ── Page ── */\n\n.page-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 1.25rem;\n}\n\n.referral-help-note {\n  flex: 0 1 16rem;\n  margin: 0.15rem 0 0 auto;\n  color: var(--color-text-muted);\n  font-size: 0.78rem;\n  line-height: 1.4;\n  text-align: right;\n\n  a {\n    color: var(--color-primary);\n    font-weight: 600;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.referral-help-note-rest {\n  display: block;\n}\n\n.page-header h1 {\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.page-subtitle {\n  color: var(--color-text-muted);\n  font-size: 0.9rem;\n  margin-top: 0.15rem;\n}\n\n.result-count {\n  font-size: 0.85rem;\n  color: var(--color-text-muted);\n  padding-top: 0.35rem;\n}\n\n/* ── Dashboard overview ── */\n\n.dashboard-overview {\n  margin-bottom: 1rem;\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n\n.dashboard-overview-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.35rem 0.75rem;\n}\n\n.dashboard-overview-toggle {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: baseline;\n  gap: 0.65rem 1rem;\n  flex: 1 1 14rem;\n  min-width: 0;\n  padding: 0.85rem 1rem;\n  border: 0;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n  color: inherit;\n}\n\n.dashboard-overview-toggle:hover {\n  background: #f7faff;\n}\n\n.dashboard-overview-controls {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.5rem 0.75rem;\n  padding: 0.45rem 1rem 0.65rem;\n}\n\n.dashboard-overview-title {\n  font-size: 0.95rem;\n  font-weight: 650;\n  color: #243447;\n}\n\n.dashboard-overview-subtitle {\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n}\n\n.dashboard-overview-chevron {\n  font-size: 0.85rem;\n  color: #5e6f84;\n  justify-self: end;\n}\n\n.dashboard-overview-body {\n  padding: 0 1rem 1rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.overview-scope-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.75rem 1rem;\n  margin-top: 0.85rem;\n}\n\n.overview-scope-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  min-width: min(100%, 16rem);\n  flex: 1 1 14rem;\n}\n\n.overview-scope-field-compact {\n  flex: 0 1 auto;\n  min-width: 8.5rem;\n}\n\n.overview-scope-field-compact .overview-scope-select {\n  max-width: 18rem;\n  min-width: 8.5rem;\n}\n\n.overview-scope-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.overview-scope-select {\n  width: 100%;\n  max-width: 22rem;\n  padding: 0.4rem 0.55rem;\n  border: 1px solid var(--color-border);\n  border-radius: 6px;\n  background: #fff;\n  font: inherit;\n  font-size: 0.875rem;\n  color: var(--color-text);\n}\n\n.overview-scope-hint {\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n  padding-bottom: 0.35rem;\n}\n\n.overview-scope-hint-error {\n  color: var(--color-error, #e43045);\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.overview-status {\n  margin: 0.85rem 0 0;\n  font-size: 0.875rem;\n  color: var(--color-text-muted);\n}\n\n.overview-status-error {\n  color: var(--color-error, #e43045);\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.overview-metric-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(9.5rem, 1fr));\n  gap: 0.75rem;\n  margin-top: 0.9rem;\n}\n\n.overview-metric {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  padding: 0.7rem 0.8rem;\n  border: 1px solid #e7eef6;\n  border-radius: var(--radius-md, 8px);\n  background: #fbfcfe;\n  min-height: 4.25rem;\n}\n\n.overview-metric-label {\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: #5e6f84;\n}\n\n.overview-metric-value {\n  font-size: 1.25rem;\n  font-weight: 650;\n  color: #243447;\n  font-variant-numeric: tabular-nums;\n  line-height: 1.2;\n}\n\n.overview-metric-hint {\n  font-size: 0.72rem;\n  color: var(--color-text-muted);\n}\n\n.overview-footer {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 0.75rem;\n}\n\n/* ── Filters ── */\n\n.filters-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  align-items: flex-end;\n  padding: 1rem;\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  margin-bottom: 1rem;\n}\n\n.filter-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--color-text-muted);\n  min-width: 140px;\n}\n\n.filter-field input,\n.filter-field select {\n  padding: 0.45rem 0.6rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  font-size: 0.9rem;\n  font-family: inherit;\n  background: var(--color-surface);\n}\n\n.filter-field input:focus,\n.filter-field select:focus {\n  outline: none;\n  border-color: var(--color-primary);\n}\n\n.filter-field-grow {\n  flex: 1 1 220px;\n  min-width: 200px;\n}\n\n.filter-clear {\n  align-self: flex-end;\n  margin-bottom: 1px;\n}\n\n/* ── Table ── */\n\n.table-wrap {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n\n.referrals-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.referrals-table th {\n  text-align: left;\n  padding: 0.75rem 1rem;\n  background: var(--color-bg);\n  font-weight: 600;\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.referrals-table td {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.referrals-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.referrals-table tbody tr:hover {\n  background: #fafbfc;\n}\n\n.referrals-table th.col-status,\n.referrals-table td.col-status {\n  min-width: 9rem;\n}\n.referrals-table th.col-date,\n.referrals-table td.col-date {\n  min-width: 8rem;\n}\n\n.referrals-table th.col-datetime,\n.referrals-table td.col-datetime {\n  min-width: 11rem;\n  white-space: nowrap;\n}\n\n.referrals-table th.col-created-by,\n.referrals-table td.col-created-by {\n  min-width: 8rem;\n}\n\n.referrals-table th.col-owner,\n.referrals-table td.col-owner {\n  min-width: 8rem;\n}\n\n.mono {\n  font-family: 'Cascadia Code', 'Consolas', monospace;\n  font-size: 0.82rem;\n}\n\n.table-empty {\n  padding: 3rem;\n  text-align: center;\n  color: var(--color-text-muted);\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n}\n\n.text-muted {\n  color: var(--color-text-muted);\n}\n\n.referral-id-link {\n  color: var(--color-primary);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.referral-id-link:hover {\n  text-decoration: underline;\n}\n\n/* Mobile card list — shown under 768px; table stays on desktop. */\n.referrals-cards {\n  display: none;\n}\n\n.referrals-cards-sort {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  margin-bottom: 0.75rem;\n}\n\n.referrals-cards-sort .th-sort {\n  padding: 0.4rem 0.65rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-sm, 6px);\n  background: var(--color-surface);\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n\n.referrals-cards-sort .th-sort-active {\n  border-color: var(--color-primary);\n  background: #edf6ff;\n  color: var(--color-primary);\n}\n\n.referrals-card-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.referral-card {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  padding: 0.9rem 1rem;\n}\n\n.referral-card-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.referral-card-head .referral-id-link {\n  font-size: 1rem;\n}\n\n.referral-card-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.65rem 1.25rem;\n  margin: 0;\n\n  > div {\n    flex: 1 1 7.5rem;\n    min-width: 0;\n  }\n\n  dt {\n    margin: 0 0 0.15rem;\n    font-size: 0.7rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    color: var(--color-text-muted);\n  }\n\n  dd {\n    margin: 0;\n    font-size: 0.875rem;\n    color: var(--color-text);\n    overflow-wrap: anywhere;\n  }\n}\n\n/* ── Referral detail ── */\n\n.back-link {\n  display: inline-block;\n  margin-bottom: 0.5rem;\n  color: var(--color-text-muted);\n  text-decoration: none;\n  font-size: 0.85rem;\n}\n\n.back-link:hover {\n  color: var(--color-primary);\n}\n\n.referral-detail {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.detail-card {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  padding: 1.25rem 1.5rem;\n}\n\n.detail-card h2 {\n  margin: 0 0 1rem;\n  font-size: 1.05rem;\n}\n\n.scheduled-appointments-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.scheduled-appointment {\n  padding: 0.85rem 1rem;\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  background: #fafbfd;\n}\n\n.scheduled-appointment .detail-meta {\n  margin: 0;\n}\n\n.detail-card-heading {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n\n  h2 {\n    margin: 0;\n  }\n}\n\n.detail-attachment-upload {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.detail-attachment-file-input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.detail-attachment-upload-btn {\n  .detail-action-btn();\n}\n\n.detail-attachment-success {\n  margin: 0 0 0.75rem;\n  color: var(--color-success, #15803d);\n  font-size: 0.88rem;\n}\n\n.detail-meta {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1rem;\n  margin: 0;\n}\n\n.detail-meta dt {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: var(--color-text-muted);\n  margin-bottom: 0.2rem;\n}\n\n.detail-meta dd {\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n.persons-involved-badges {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.person-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  max-width: 100%;\n  padding: 0.4rem 0.75rem;\n  border: 1px solid var(--color-border);\n  border-radius: 999px;\n  background: var(--color-bg, #f8fafc);\n  color: inherit;\n  text-decoration: none;\n  font-size: 0.85rem;\n  line-height: 1.2;\n}\n\n.person-badge.is-patient {\n  border-color: var(--color-primary);\n  border-width: 2px;\n  background: #e8f2ff;\n  box-shadow: 0 0 0 1px fade(#2b6cb0, 12%);\n}\n\na.person-badge:hover {\n  border-color: var(--color-primary);\n  background: #edf6ff;\n}\n\na.person-badge.is-patient:hover {\n  background: #dcecff;\n}\n\n.person-badge-name {\n  font-weight: 600;\n  color: var(--color-text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.person-badge-type {\n  flex-shrink: 0;\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--color-text-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n.referral-updates-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.referral-updates-new-count {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 0.55rem;\n  padding: 0.12rem 0.5rem;\n  border-radius: 999px;\n  background: #edf6ff;\n  border: 1px solid fade(#2b6cb0, 28%);\n  color: var(--color-primary, #2b6cb0);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  vertical-align: middle;\n}\n\n.referral-update {\n  --update-accent: var(--color-border);\n  padding: 0.85rem 1rem;\n  border: 1px solid var(--color-border);\n  border-left: 3px solid var(--update-accent);\n  border-radius: var(--radius-md, 8px);\n  background: var(--color-bg, #f8fafc);\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.referral-update--adjuster {\n  --update-accent: #2b6cb0;\n}\n\n.referral-update--admin {\n  --update-accent: #6b46c1;\n}\n\n.referral-update--provider {\n  --update-accent: #2f855a;\n}\n\n.referral-update--manager {\n  --update-accent: #c05621;\n}\n\n.referral-update--inspire {\n  --update-accent: #319795;\n}\n\n.referral-update--system {\n  --update-accent: #718096;\n}\n\n.referral-update.is-new {\n  background: #f3f8ff;\n  box-shadow: none;\n}\n\n.referral-update-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.35rem 1rem;\n  margin-bottom: 0.45rem;\n  font-size: 0.78rem;\n  color: var(--color-text-muted);\n\n  time {\n    font-weight: 600;\n    color: var(--color-text);\n  }\n}\n\n.referral-update-meta-left {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.referral-update-type {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.06rem 0.4rem;\n  border-radius: 4px;\n  border: 1px solid fade(#000, 8%);\n  background: fade(#fff, 70%);\n  color: var(--update-accent, var(--color-text-muted));\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.referral-update-meta-right {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.referral-update-new-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.08rem 0.4rem;\n  border-radius: 999px;\n  background: var(--color-primary, #2b6cb0);\n  color: #fff;\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.referral-update-by {\n  &::before {\n    content: 'by ';\n    font-weight: 400;\n    color: var(--color-text-muted);\n  }\n}\n\n.referral-update-description {\n  margin: 0;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  color: var(--color-text);\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.referral-updates-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 0.85rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.referral-post-update-btn {\n  .detail-action-btn();\n}\n\n/* ── Form tiles ── */\n\n.form-tile-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 1rem;\n}\n\n.form-tile {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.85rem;\n  padding: 1rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  background: var(--color-surface);\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n  transition: border-color 0.15s, box-shadow 0.15s, transform 0.05s;\n}\n\n.form-tile:hover {\n  border-color: var(--color-primary);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\n}\n\n.form-tile:active {\n  transform: translateY(1px);\n}\n\n.form-tile-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  flex-shrink: 0;\n  border-radius: var(--radius);\n  background: var(--color-primary-light);\n  color: var(--color-primary);\n}\n\n.form-tile-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  min-width: 0;\n}\n\n.form-tile-title {\n  font-weight: 600;\n  font-size: 0.92rem;\n  line-height: 1.3;\n}\n\n.form-tile-source {\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n}\n\n.form-tile-meta {\n  font-size: 0.75rem;\n  color: var(--color-text-muted);\n}\n\n/* ── Detail attachments ── */\n\n.detail-attachment-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.detail-attachment-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.75rem 0.85rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md, 8px);\n  background: var(--color-bg, #f8fafc);\n}\n\n.detail-attachment-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  flex-shrink: 0;\n  border-radius: var(--radius, 6px);\n  background: var(--color-primary-light, #e0f2fe);\n  color: var(--color-primary);\n}\n\n.detail-attachment-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 0;\n}\n\n.detail-attachment-name {\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: var(--color-text);\n  word-break: break-word;\n}\n\nbutton.detail-attachment-link {\n  color: var(--color-primary);\n  text-decoration: none;\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  font: inherit;\n  font-weight: 600;\n  font-size: 0.9rem;\n  text-align: left;\n  cursor: pointer;\n  word-break: break-word;\n}\n\nbutton.detail-attachment-link:hover:not(:disabled) {\n  text-decoration: underline;\n}\n\nbutton.detail-attachment-link:disabled {\n  opacity: 0.7;\n  cursor: wait;\n}\n\n.detail-attachment-download {\n  .detail-action-btn();\n  align-self: flex-start;\n  margin-top: 0.35rem;\n}\n\n.detail-attachment-download:disabled {\n  opacity: 0.7;\n  cursor: wait;\n}\n\n.detail-attachment-error {\n  margin: 0 0 0.75rem;\n  color: var(--color-error);\n  font-size: 0.85rem;\n}\n\n.detail-attachment-meta {\n  font-size: 0.78rem;\n  color: var(--color-text-muted);\n}\n\n.detail-forms-hint {\n  margin: 0 0 0.75rem;\n}\n\n/* ── Form modal ── */\n\n.form-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 3vh 1rem;\n  background: rgba(15, 23, 42, 0.45);\n  overflow-y: auto;\n}\n\n.form-modal {\n  width: 100%;\n  max-width: 920px;\n  background: var(--color-bg);\n  border-radius: var(--radius-lg);\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);\n  display: flex;\n  flex-direction: column;\n  max-height: 94vh;\n}\n\n.form-modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid var(--color-border);\n  background: var(--color-surface);\n  border-radius: var(--radius-lg) var(--radius-lg) 0 0;\n}\n\n.form-modal-header h2 {\n  margin: 0;\n  font-size: 1.05rem;\n}\n\n.form-modal-source {\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n}\n\n.form-modal-close {\n  border: none;\n  background: none;\n  font-size: 1.1rem;\n  line-height: 1;\n  padding: 0.35rem 0.5rem;\n  border-radius: var(--radius);\n  cursor: pointer;\n  color: var(--color-text-muted);\n}\n\n.form-modal-close:hover {\n  background: var(--color-bg);\n  color: var(--color-text);\n}\n\n.form-modal-close:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.form-modal-body {\n  overflow-y: auto;\n  padding: 0.5rem 1rem 1rem;\n}\n\n/* ── Pagination ── */\n\n.pagination {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.pagination-info {\n  grid-column: 1;\n  justify-self: start;\n  font-size: 0.85rem;\n  color: var(--color-text-muted);\n}\n\n.pagination-controls {\n  grid-column: 2;\n  justify-self: center;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.pagination-page {\n  font-size: 0.85rem;\n  color: var(--color-text-muted);\n}\n\n.pagination-controls .btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination-pages {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.pagination-page-btn {\n  min-width: 2rem;\n  height: 2rem;\n  padding: 0 0.5rem;\n  border: 1px solid var(--color-border);\n  background: var(--color-surface, #fff);\n  border-radius: var(--radius);\n  font-size: 0.85rem;\n  color: var(--color-text, #0f172a);\n  cursor: pointer;\n}\n\n.pagination-page-btn:hover:not(:disabled):not(.active) {\n  background: var(--color-bg);\n}\n\n.pagination-page-btn.active {\n  background: var(--color-primary);\n  border-color: var(--color-primary);\n  color: #fff;\n  font-weight: 600;\n}\n\n.pagination-page-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination-gap {\n  padding: 0 0.25rem;\n  color: var(--color-text-muted);\n}\n\n.pagination-jump {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.85rem;\n  color: var(--color-text-muted);\n}\n\n.pagination-jump input {\n  width: 4rem;\n  height: 2rem;\n  padding: 0 0.5rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  font-size: 0.85rem;\n}\n\n/* Sortable column headers */\n.referrals-table th {\n  padding: 0;\n}\n\n.th-sort {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font: inherit;\n  font-weight: 600;\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.th-sort:hover {\n  color: var(--color-text, #0f172a);\n}\n\n.th-sort-active {\n  color: var(--color-primary);\n}\n\n.th-sort-arrow {\n  font-size: 0.7rem;\n  opacity: 0.5;\n}\n\n.th-sort-active .th-sort-arrow {\n  opacity: 1;\n}\n\n/* ── Badges ── */\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.28rem 0.72rem 0.28rem 0.55rem;\n  border-radius: 999px;\n  background: #eef1f4;\n  color: #8b939e;\n  font-size: 0.82rem;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.status-badge-dot {\n  width: 0.45rem;\n  height: 0.45rem;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.status-tone-received {\n  background: #e7f2ff;\n  color: #2f7de1;\n}\n\n.status-tone-scheduling {\n  background: #fff3dc;\n  color: #c48a12;\n}\n\n.status-tone-scheduled {\n  background: #e5f7ec;\n  color: #2f9d57;\n}\n\n.status-tone-seen,\n.status-tone-neutral {\n  background: #eef1f4;\n  color: #8b939e;\n}\n\n.status-tone-unable {\n  background: #fdecec;\n  color: #e23b3b;\n}\n\n.type-badge {\n  display: inline-block;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.status-0 {\n  background: var(--color-primary-light);\n  color: var(--color-primary);\n}\n\n.status-1 {\n  background: #fef9e7;\n  color: var(--color-warning);\n}\n\n.status-2 {\n  background: var(--color-success-bg);\n  color: var(--color-success);\n}\n\n.status-3 {\n  background: #f0f0f5;\n  color: #555;\n}\n\n/* ── Tabs ── */\n\n.tab-bar {\n  display: flex;\n  gap: 0.25rem;\n  margin-bottom: 1.25rem;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.tab {\n  padding: 0.6rem 1.1rem;\n  border: none;\n  background: none;\n  font-family: inherit;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: var(--color-text-muted);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  transition: color 0.15s;\n}\n\n.tab:hover {\n  color: var(--color-text);\n}\n\n.tab.active {\n  color: var(--color-primary);\n  border-bottom-color: var(--color-primary);\n}\n\n/* ── Form switcher (referral + added supporting forms) ── */\n\n.form-switcher {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n  margin: -0.5rem 0 1.25rem;\n}\n\n.form-switcher-item {\n  display: inline-flex;\n  align-items: stretch;\n  max-width: 100%;\n  border: 1px solid var(--color-border);\n  border-radius: 999px;\n  background: var(--color-surface, #fff);\n  overflow: hidden;\n}\n\n.form-switcher-item.active {\n  border-color: var(--color-primary);\n  background: #eef2ff;\n}\n\n.form-switcher-tab {\n  padding: 0.45rem 0.9rem;\n  border: 1px solid var(--color-border);\n  border-radius: 999px;\n  background: var(--color-surface, #fff);\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--color-text-muted);\n  cursor: pointer;\n  transition: color 0.15s, border-color 0.15s, background 0.15s;\n}\n\n.form-switcher-item .form-switcher-tab {\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n}\n\n.form-switcher-item.active .form-switcher-tab {\n  color: var(--color-primary);\n}\n\n.form-switcher-tab:hover {\n  color: var(--color-text);\n  border-color: var(--color-text-muted);\n}\n\n.form-switcher-tab.active {\n  color: var(--color-primary);\n  border-color: var(--color-primary);\n  background: #eef2ff;\n}\n\n.form-switcher-remove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.6rem;\n  padding: 0 0.45rem 0 0.15rem;\n  border: 0;\n  background: transparent;\n  color: var(--color-text-muted);\n  font-size: 1rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.form-switcher-remove:hover {\n  color: var(--color-error, #e43045);\n}\n\n.form-switcher-tab--add {\n  border-style: dashed;\n}\n\n.form-switcher-tab--add.is-open,\n.form-switcher-tab--add:hover {\n  color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n.add-form-menu {\n  position: relative;\n}\n\n.add-form-menu-list {\n  position: absolute;\n  top: calc(100% + 0.4rem);\n  left: 0;\n  z-index: 60;\n  min-width: 16rem;\n  max-width: min(22rem, 80vw);\n  margin: 0;\n  padding: 0.35rem;\n  list-style: none;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg, 10px);\n  background: var(--color-surface, #fff);\n  box-shadow: var(--shadow);\n}\n\n.add-form-menu-option {\n  display: block;\n  width: 100%;\n  padding: 0.55rem 0.7rem;\n  border: 0;\n  border-radius: var(--radius, 6px);\n  background: transparent;\n  color: var(--color-text);\n  font: inherit;\n  font-size: 0.85rem;\n  text-align: left;\n  cursor: pointer;\n}\n\n.add-form-menu-option:hover {\n  background: #eef2ff;\n  color: var(--color-primary);\n}\n\n/* New Referral: compact sticky chrome + form switcher */\n.page--new-referral {\n  .new-referral-chrome {\n    position: sticky;\n    top: 0;\n    z-index: 50;\n    margin: -0.35rem 0 0.85rem;\n    padding: 0.35rem 0 0.65rem;\n    background: var(--color-bg);\n    border-bottom: 1px solid var(--color-border);\n    box-shadow: 0 8px 12px -10px fade(@navy, 18%);\n  }\n\n  .page-header--compact {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: baseline;\n    gap: 0.35rem 0.75rem;\n    margin-bottom: 0.35rem;\n\n    h1 {\n      font-size: 1.05rem;\n      font-weight: 700;\n      letter-spacing: -0.02em;\n      line-height: 1.2;\n    }\n\n    .page-subtitle {\n      margin: 0;\n      font-size: 0.8rem;\n      line-height: 1.3;\n      color: var(--color-text-muted);\n    }\n  }\n\n  .tab-bar {\n    margin-bottom: 0.5rem;\n  }\n\n  .tab {\n    padding: 0.4rem 0.85rem;\n    font-size: 0.82rem;\n  }\n\n  .form-switcher {\n    margin: 0;\n    gap: 0.35rem;\n  }\n\n  .new-referral-mode {\n    display: inline-flex;\n    gap: 0;\n    margin-bottom: 1rem;\n    padding: 0.2rem;\n    border: 1px solid @border;\n    border-bottom: 1px solid @border;\n    border-radius: 10px;\n    background: #fff;\n\n    .tab {\n      margin: 0;\n      padding: 0.4rem 0.9rem;\n      border: 0;\n      border-radius: 8px;\n      color: @muted;\n      font-size: 0.85rem;\n      font-weight: 600;\n\n      &.active {\n        color: @navy;\n        background: #e7f1ff;\n      }\n    }\n  }\n\n  .new-referral-workspace {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 320px;\n    gap: 1rem;\n    align-items: start;\n\n    &.is-assistant-hidden {\n      grid-template-columns: minmax(0, 1fr);\n    }\n  }\n\n  .new-referral-form {\n    min-width: 0;\n  }\n\n  .assistant-show-fab {\n    position: fixed;\n    right: 1.25rem;\n    bottom: 5.5rem;\n    z-index: 30;\n    border: 1px solid @primary;\n    border-radius: 999px;\n    background: @primary;\n    color: #fff;\n    font: inherit;\n    font-size: 0.85rem;\n    font-weight: 600;\n    padding: 0.55rem 0.9rem;\n    box-shadow: 0 6px 16px fade(@primary, 28%);\n    cursor: pointer;\n\n    &:hover {\n      background: @primary-hover;\n    }\n  }\n\n  .referral-steps {\n    display: flex;\n    gap: 0.75rem;\n    margin: 0 0 0.85rem;\n    padding: 0;\n    list-style: none;\n  }\n\n  .referral-step {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .referral-step-btn {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    gap: 0.45rem;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: @muted;\n    font: inherit;\n    font-size: 0.82rem;\n    text-align: left;\n    cursor: pointer;\n  }\n\n  .referral-step-index {\n    display: inline-flex;\n    width: 1.35rem;\n    height: 1.35rem;\n    flex-shrink: 0;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    background: #e6ecf2;\n    color: @muted;\n    font-size: 0.75rem;\n    font-weight: 700;\n  }\n\n  .referral-step-label {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .referral-step.is-current .referral-step-index,\n  .referral-step.is-done .referral-step-index {\n    background: @primary;\n    color: #fff;\n  }\n\n  .referral-step.is-current .referral-step-label {\n    color: @navy;\n    font-weight: 600;\n  }\n\n  .referral-step.is-current .referral-step-btn {\n    box-shadow: inset 0 -2px 0 @primary;\n    padding-bottom: 0.35rem;\n  }\n\n  .new-referral-nav {\n    position: sticky;\n    bottom: 0;\n    z-index: 5;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n    margin-top: 0.75rem;\n    padding: 0.75rem 0.15rem 0.15rem;\n    background: linear-gradient(180deg, fade(@sky, 0%) 0%, @sky 28%);\n  }\n\n  .new-referral-draft {\n    color: @muted;\n    font-size: 0.82rem;\n  }\n\n  .new-referral-nav-actions {\n    display: flex;\n    gap: 0.5rem;\n  }\n\n  .sd-action-bar {\n    display: none;\n  }\n\n  .sd-selectbase {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.75rem;\n  }\n\n  .sd-selectbase .sd-item {\n    flex: 1 1 220px;\n    margin: 0;\n    padding: 0.85rem 1rem;\n    border: 1px solid @border;\n    border-radius: 10px;\n    background: #fff;\n  }\n\n  .sd-selectbase .sd-item--checked {\n    border-color: @primary;\n    background: #f4f8ff;\n    box-shadow: 0 0 0 1px @primary;\n  }\n\n  .sd-html {\n    margin-bottom: 0.85rem;\n    font-size: 0.88rem;\n    line-height: 1.45;\n  }\n\n  .form-switcher-tab {\n    padding: 0.3rem 0.7rem;\n    font-size: 0.78rem;\n  }\n\n  .form-switcher-remove {\n    min-width: 1.35rem;\n    font-size: 0.95rem;\n  }\n\n  .add-form-menu-option {\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 900px) {\n  .page--new-referral .new-referral-workspace {\n    grid-template-columns: 1fr;\n  }\n\n  .referral-help-note {\n    flex-basis: 100%;\n    margin-left: 0;\n    text-align: left;\n  }\n}\n\n.form-load-error {\n  padding: 2rem;\n  text-align: center;\n  color: var(--color-error);\n}\n\n.form-load-error p {\n  margin-bottom: 1rem;\n}\n\n/* ── SurveyJS overrides ── */\n\n.survey-container {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  padding: 0.75rem;\n  position: relative;\n}\n\n.survey-container .sd-root-modern {\n  --sjs-primary-backcolor: var(--color-primary);\n  --sjs-primary-backcolor-dark: var(--color-primary-hover);\n  --sjs-general-backcolor: var(--color-surface);\n  --sjs-border-default: var(--color-border);\n}\n\n.survey-container,\n.survey-panel-side,\n.form-modal {\n  .sd-root-modern {\n    --sjs-base-unit: 6px;\n    --sd-base-padding: 5px;\n    --sd-base-vertical-padding: 8px;\n    --sd-page-vertical-padding: 8px;\n  }\n\n  .sd-root-modern,\n  .sd-container-modern,\n  .sd-body,\n  .sd-body__page,\n  .sd-page {\n    max-width: none;\n    width: 100%;\n  }\n\n  .sd-element,\n  .sd-row,\n  .sd-question {\n    margin-top: 0.35rem;\n    margin-bottom: 0.35rem;\n  }\n\n  .sd-question__title {\n    margin-bottom: 0.2rem;\n  }\n\n  .sd-question__description {\n    margin-top: 0.15rem;\n  }\n\n  .sd-panel__title,\n  .sd-page__title {\n    margin-bottom: 0.35rem;\n  }\n}\n\n.overlay-msg {\n  position: absolute;\n  inset: 0;\n  background: rgba(255, 255, 255, 0.78);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 500;\n  z-index: 10;\n  border-radius: var(--radius-lg);\n}\n\n/* Pin to the viewport so long forms still show the spinner on-screen. */\n.overlay-msg--viewport {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  border-radius: 0;\n  background: rgba(15, 23, 42, 0.35);\n}\n\n.overlay-msg-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.85rem;\n  padding: 1.25rem 1.5rem;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.98);\n  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.18);\n  color: var(--color-text);\n  font-size: 0.95rem;\n}\n\n.overlay-msg-content .spinner {\n  width: 36px;\n  height: 36px;\n}\n\n/* ── Upload ── */\n\n.upload-panel {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  padding: 2rem;\n}\n\n.upload-test-note {\n  margin: 1rem 0 0;\n  font-size: 0.875rem;\n  color: var(--color-text-muted, #64748b);\n}\n\n.upload-test-note code {\n  font-size: 0.8125rem;\n}\n\n.upload-dropzone input[type='file'] {\n  display: none;\n}\n\n.upload-dropzone label {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 3rem 2rem;\n  border: 2px dashed var(--color-border);\n  border-radius: var(--radius-lg);\n  cursor: pointer;\n  text-align: center;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.upload-dropzone label:hover {\n  border-color: var(--color-primary);\n  background: var(--color-primary-light);\n}\n\n.upload-dropzone strong {\n  font-size: 1rem;\n}\n\n.upload-dropzone span {\n  font-size: 0.85rem;\n  color: var(--color-text-muted);\n}\n\n.upload-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  margin-top: 1.25rem;\n}\n\n/* ── Loading ── */\n\n.loading-screen {\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  color: var(--color-text-muted);\n}\n\n.spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid var(--color-border);\n  border-top-color: var(--color-primary);\n  border-radius: 50%;\n  animation: spin 0.7s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ── Responsive ── */\n\n@media (max-width: 768px) {\n  .app-main {\n    padding: 1rem;\n  }\n\n  .filters-bar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .filter-field {\n    min-width: unset;\n  }\n\n  .referrals-table-desktop {\n    display: none;\n  }\n\n  .referrals-cards {\n    display: block;\n  }\n\n  .page-header {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n}\n\n/* ── Figma-aligned visual system ── */\n\nbody {\n  background: @sky;\n  font-size: 14px;\n}\n\na,\nbutton,\ninput,\nselect,\ntextarea {\n  &:focus-visible {\n    outline: 3px solid fade(@primary, 28%);\n    outline-offset: 2px;\n  }\n}\n\n.btn {\n  min-height: 36px;\n  padding: 0.55rem 1.15rem;\n  border-radius: 6px;\n  font-weight: 600;\n  letter-spacing: 0.005em;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease,\n    transform 0.15s ease;\n\n  &:active:not(:disabled) {\n    transform: translateY(1px);\n  }\n}\n\n.btn-primary {\n  background: @primary;\n  box-shadow: 0 4px 10px fade(@primary, 20%);\n}\n\n.btn-secondary {\n  color: @navy;\n  border-color: #c8d6e5;\n}\n\n.btn-ghost {\n  color: @navy;\n  background: @surface;\n}\n\n/* Login */\n\n.login-page {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(420px, 576px);\n  min-height: 100vh;\n  padding: 0;\n  background: @surface;\n}\n\n.login-visual {\n  position: relative;\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow: hidden;\n  padding: clamp(2rem, 4vw, 4rem);\n  color: #fff;\n  background: #0b1932;\n\n  &::before {\n    position: absolute;\n    inset: 0;\n    background-image:\n      linear-gradient(fade(#fff, 3%) 1px, transparent 1px),\n      linear-gradient(90deg, fade(#fff, 3%) 1px, transparent 1px);\n    background-size: 46px 46px;\n    content: '';\n    -webkit-mask-image: linear-gradient(to bottom, #000, transparent 85%);\n    mask-image: linear-gradient(to bottom, #000, transparent 85%);\n  }\n\n  p {\n    position: relative;\n    z-index: 1;\n    margin: 0;\n    color: fade(#fff, 68%);\n    font-size: 0.85rem;\n    letter-spacing: 0.04em;\n  }\n}\n\n.login-visual-brand {\n  position: relative;\n  z-index: 1;\n  display: block;\n  width: 200px;\n  object-fit: contain;\n}\n\n.login-illustration {\n  position: absolute;\n  z-index: 0;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  filter: drop-shadow(0 28px 45px fade(#000, 24%));\n}\n\n.login-panel {\n  position: relative;\n  display: grid;\n  width: 100%;\n  max-width: 576px;\n  min-height: 100vh;\n  justify-self: end;\n  place-items: center;\n  padding: 3rem clamp(2rem, 5vw, 4.5rem) 5rem;\n}\n\n.login-card {\n  width: 100%;\n  max-width: 430px;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.login-header {\n  margin-bottom: 2rem;\n  text-align: center;\n\n  h1 {\n    margin-top: 1.5rem;\n    color: @text;\n    font-size: clamp(1.45rem, 2vw, 1.85rem);\n    font-weight: 700;\n    letter-spacing: -0.025em;\n  }\n\n  p {\n    margin-top: 0.5rem;\n    color: @muted;\n  }\n}\n\n.login-logo {\n  display: inline-block;\n  max-height: 100px;\n  object-fit: contain;\n}\n\n.login-form {\n  gap: 1.15rem;\n\n  label {\n    gap: 0.45rem;\n    color: @text;\n    font-size: 0.8rem;\n    font-weight: 600;\n  }\n\n  input {\n    min-height: 44px;\n    padding: 0.7rem 0.85rem;\n    border-color: #cdd8e4;\n    border-radius: @radius;\n    color: @text;\n\n    &:focus {\n      .focus-ring();\n    }\n  }\n\n  .btn {\n    min-height: 42px;\n    margin-top: 0.25rem;\n  }\n}\n\n.login-divider {\n  margin: 1.4rem 0;\n}\n\n.footer-need-help {\n  position: absolute;\n  right: clamp(2rem, 5vw, 4.5rem);\n  bottom: 1.5rem;\n  left: clamp(2rem, 5vw, 4.5rem);\n  color: @muted;\n  font-size: 0.82rem;\n  text-align: left;\n\n  a {\n    color: #2671ff;\n    font-weight: 500;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n/* Shared shell */\n\n.app-header {\n  min-height: 72px;\n  padding: 0;\n  border: 0;\n  border-bottom: 1px solid #c5d0dc;\n  background: linear-gradient(180deg, #f4f7fa 0%, #e6ecf2 100%);\n}\n\n.app-header-inner,\n.app-nav-inner {\n  display: flex;\n  width: 100%;\n  max-width: 1500px;\n  margin: 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  padding-inline: clamp(1rem, 3vw, 2.5rem);\n}\n\n.app-header-inner {\n  position: relative;\n  min-height: 72px;\n}\n\n.header-brand {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  color: @navy;\n  font-size: 0.92rem;\n  text-decoration: none;\n  z-index: 1;\n}\n\n.header-logo {\n  width: auto;\n  height: 34px;\n  object-fit: contain;\n  /* SVG wordmark is white; tint to navy on the light header. */\n  filter: brightness(0) saturate(100%) invert(14%) sepia(55%) saturate(2200%)\n    hue-rotate(199deg) brightness(92%) contrast(101%);\n}\n\n.header-client-logo {\n  position: absolute;\n  left: 50%;\n  top: 0;\n  bottom: 0;\n  transform: translateX(-50%);\n  height: 100%;\n  width: auto;\n  max-height: 100%;\n  object-fit: contain;\n  object-position: center;\n  border-radius: 0;\n  box-shadow: none;\n  pointer-events: none;\n}\n\n.header-brand-divider {\n  width: 1px;\n  height: 24px;\n  margin-inline: 0.15rem;\n  background: fade(@navy, 22%);\n}\n\n.header-product {\n  font-weight: 600;\n}\n\n.header-actions {\n  gap: 0.85rem;\n  z-index: 1;\n}\n\n.user-label {\n  color: fade(@navy, 78%);\n  border-radius: 999px;\n\n  &:hover,\n  &.is-open {\n    color: @navy;\n    background: fade(@navy, 8%);\n  }\n}\n\n.btn-header {\n  min-height: 32px;\n  padding: 0.35rem 0.9rem;\n  border: 1px solid fade(@navy, 35%);\n  color: @navy;\n  background: transparent;\n\n  &:hover {\n    border-color: @navy;\n    background: fade(@navy, 8%);\n  }\n}\n\n.user-menu-panel {\n  .surface-card();\n  top: calc(100% + 0.65rem);\n}\n\n.app-nav {\n  min-height: 52px;\n  padding: 0;\n  background: @surface;\n  border-bottom-color: @border;\n}\n\n.app-nav-inner {\n  min-height: 52px;\n}\n\n.nav-tabs {\n  display: flex;\n  align-self: stretch;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.nav-link {\n  position: relative;\n  display: inline-flex;\n  min-height: 52px;\n  align-items: center;\n  padding: 0.55rem 0.7rem;\n  border-radius: 0;\n  color: @muted;\n  font-size: 0.8rem;\n\n  &::after {\n    position: absolute;\n    right: 0.7rem;\n    bottom: -1px;\n    left: 0.7rem;\n    height: 2px;\n    border-radius: 2px 2px 0 0;\n    background: transparent;\n    content: '';\n  }\n\n  &:hover {\n    color: @primary;\n    background: transparent;\n  }\n\n  &.active {\n    color: @primary;\n\n    &::after {\n      background: @primary;\n    }\n  }\n}\n\n.nav-link-primary {\n  min-height: 34px;\n  padding: 0.45rem 1rem;\n  gap: 0.45rem;\n  border-radius: 999px;\n  color: #fff;\n  background: @primary;\n  box-shadow: 0 3px 9px fade(@primary, 20%);\n\n  &::after {\n    display: none;\n  }\n\n  &:hover {\n    color: #fff;\n    background: @primary-hover;\n  }\n}\n\n.nav-new-icon {\n  display: inline-flex;\n  width: 20px;\n  height: 20px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-size: 1rem;\n  line-height: 1;\n}\n\n.app-main {\n  max-width: 1500px;\n  padding: clamp(1.25rem, 3vw, 2.5rem);\n}\n\n.app-footer {\n  width: 100%;\n  margin-top: auto;\n  padding: 0;\n  border-top: 1px solid #dce7f6;\n  color: #53647b;\n  background: #f3f7ff;\n}\n\n.app-footer-inner {\n  width: 100%;\n\n  margin: 0 auto;\n  text-align: center;\n\n  p {\n    margin: 0;\n    font-size: 0.75rem;\n    line-height: 1.55;\n  }\n\n  a {\n    color: #0b2f73;\n    font-weight: 700;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.app-footer-powered {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.65rem;\n  width: 100%;\n  margin: 0%;\n  padding: 0.75rem clamp(1rem, 3vw, 2.5rem);\n  background: @navy;\n  color: fade(#fff, 78%);\n}\n\n.app-footer-powered-label {\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.app-footer-powered-logo {\n  width: auto;\n  height: 36px;\n  object-fit: contain;\n}\n\n.app-footer-privacy {\n  max-width: 1180px;\n  margin: 0.3rem auto 0 !important;\n  font-size: 10px !important;\n  line-height: 1.45 !important;\n}\n\n/* Content and data surfaces */\n\n.page-header {\n  margin-bottom: 1.5rem;\n  align-items: center;\n\n  h1 {\n    color: @text;\n    font-size: clamp(1.35rem, 2vw, 1.7rem);\n    font-weight: 700;\n    letter-spacing: -0.025em;\n  }\n}\n\n.page-subtitle {\n  margin-top: 0.3rem;\n  color: @muted;\n}\n\n.result-count {\n  padding: 0.35rem 0.75rem;\n  border-radius: 999px;\n  color: @navy;\n  background: #e4f0ff;\n  font-weight: 600;\n}\n\n.filters-panel {\n  margin-bottom: 1rem;\n  overflow: hidden;\n  border: 1px solid @border;\n  border-radius: @radius-lg;\n  background: @surface;\n  box-shadow: 0 5px 18px fade(@navy, 5%);\n}\n\n.filters-toggle {\n  display: flex;\n  width: 100%;\n  min-height: 48px;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 1.15rem;\n  border: 0;\n  color: @text;\n  background: @surface;\n  font: inherit;\n  font-size: 0.85rem;\n  font-weight: 700;\n  cursor: pointer;\n\n  &:hover {\n    background: #f8fbff;\n  }\n}\n\n.filters-toggle-meta {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.filters-toggle-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.filters-icon {\n  width: 17px;\n  height: 17px;\n  color: @primary;\n  stroke-width: 1.8;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.filters-active-count {\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  color: @primary;\n  background: #e9f3ff;\n  font-size: 0.7rem;\n  font-weight: 600;\n}\n\n.filters-chevron {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  color: @primary;\n  background: #e9f3ff;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  transition: transform 0.15s ease;\n}\n\n.filters-panel.is-expanded .filters-chevron {\n  transform: rotate(180deg);\n}\n\n.filters-bar {\n  margin: 0;\n  padding: 1rem 1.15rem 1.15rem;\n  border: 0;\n  border-top: 1px solid #e7eef6;\n  border-radius: 0;\n  background: #fbfdff;\n\n  .filter-field {\n    color: @muted;\n    font-size: 0.74rem;\n    font-weight: 600;\n\n    input,\n    select {\n      min-height: 38px;\n      border-color: #cad7e4;\n      border-radius: @radius;\n      color: @text;\n\n      &:focus {\n        .focus-ring();\n      }\n    }\n  }\n}\n\n.filter-actions {\n  display: flex;\n  flex: 1 0 100%;\n  align-self: flex-end;\n  justify-content: flex-end;\n  gap: 0.55rem;\n  margin-top: 0.15rem;\n  margin-left: 0;\n\n  .btn {\n    min-width: 84px;\n  }\n}\n\n.table-wrap {\n  border-color: @border;\n  border-top: 1px solid @border;\n  border-radius: @radius-lg;\n  box-shadow: @shadow;\n}\n\n.referrals-table {\n  font-size: 0.82rem;\n\n  th {\n    background: #f7faff;\n    border-color: @border;\n  }\n\n  td {\n    padding: 0.7rem 1rem;\n    border-color: #e7eef6;\n    color: #344357;\n  }\n\n  tbody tr {\n    transition: background 0.12s ease;\n\n    &:hover {\n      background: #f3f8ff;\n    }\n  }\n}\n\n.th-sort {\n  color: #5e6f84;\n  font-size: 0.72rem;\n  letter-spacing: 0.025em;\n}\n\n.referral-id-link {\n  color: #2f64b8;\n}\n\n.detail-header-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.detail-action-btn() {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 36px;\n  padding: 0.45rem 0.95rem;\n  border: 1px solid #c5daf5;\n  border-radius: 6px;\n  background: #e6f1ff;\n  color: #000;\n  font: inherit;\n  font-size: 0.85rem;\n  font-weight: 600;\n  line-height: 1.2;\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    background: #d4e6fb;\n    border-color: #b7d0f0;\n    color: #000;\n    text-decoration: none;\n  }\n\n  &:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 3px fade(#e6f1ff, 80%);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.detail-update-inspire-btn {\n  .detail-action-btn();\n}\n\n.update-inspire-modal {\n  max-width: 520px;\n  margin-top: 12vh;\n}\n\n.update-inspire-modal-body {\n  padding: 1.1rem 1.25rem 1.25rem;\n}\n\n.detail-update-inspire-label {\n  display: block;\n  margin-bottom: 0.4rem;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.detail-update-inspire-textarea {\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n  margin: 0 0 0.75rem;\n  padding: 0.65rem 0.75rem;\n  border: 1px solid var(--color-border);\n  border-radius: 6px;\n  font: inherit;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  resize: vertical;\n  min-height: 5.5rem;\n  background: var(--color-surface, #fff);\n  color: var(--color-text);\n}\n\n.detail-update-inspire-textarea:focus {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 1px;\n}\n\n.detail-update-inspire-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n}\n\n.status-0 {\n  color: #fff;\n  background: #21833f;\n}\n\n.status-1 {\n  color: #fff;\n  background: #eea62b;\n}\n\n.status-2 {\n  color: #fff;\n  background: #858b95;\n}\n\n.status-3 {\n  color: #fff;\n  background: #eb3349;\n}\n\n.status-badge.status-0 {\n  background: #e5f6eb;\n  color: #1c7a38;\n}\n\n.status-badge.status-1 {\n  background: #fff1d6;\n  color: #c47d08;\n}\n\n.status-badge.status-2 {\n  background: #eef1f4;\n  color: #6d7580;\n}\n\n.status-badge.status-3 {\n  background: #fde8eb;\n  color: #d1263c;\n}\n\n.status-badge.status-tone-received {\n  background: #e7f2ff;\n  color: #1d6fd4;\n}\n\n.status-badge.status-tone-scheduling {\n  background: #fff1d6;\n  color: #c47d08;\n}\n\n.status-badge.status-tone-scheduled {\n  background: #e5f6eb;\n  color: #1c7a38;\n}\n\n.status-badge.status-tone-seen,\n.status-badge.status-tone-neutral {\n  background: #eef1f4;\n  color: #6d7580;\n}\n\n.status-badge.status-tone-unable {\n  background: #fde8eb;\n  color: #d1263c;\n}\n\n.pagination {\n  margin-top: 1.25rem;\n  padding-inline: 0.25rem;\n}\n\n.pagination-controls {\n  gap: 0.45rem;\n}\n\n.pagination-page-btn {\n  border-radius: 5px;\n\n  &.active {\n    background: @primary;\n    border-color: @primary;\n  }\n}\n\n.pagination-jump input {\n  &:focus {\n    .focus-ring();\n  }\n}\n\n/* Details, tabs, forms, and overlays */\n\n.back-link {\n  color: @primary;\n  font-weight: 600;\n}\n\n.referral-detail {\n  gap: 1rem;\n}\n\n.detail-card {\n  .surface-card();\n  padding: 1.35rem 1.5rem;\n\n  h2 {\n    padding-bottom: 0.8rem;\n    border-bottom: 1px solid #e7eef6;\n    color: @text;\n    font-size: 1rem;\n  }\n}\n\n.detail-meta {\n  gap: 1.25rem 1.5rem;\n\n  dt {\n    color: @muted;\n    font-size: 0.7rem;\n    font-weight: 600;\n  }\n\n  dd {\n    color: @text;\n    font-weight: 500;\n  }\n}\n\n.form-tile {\n  border-color: @border;\n  box-shadow: 0 3px 12px fade(@navy-deep, 5%);\n\n  &:hover {\n    border-color: @primary;\n    box-shadow: 0 7px 18px fade(@primary, 12%);\n  }\n}\n\n.form-tile-icon {\n  color: @primary;\n  background: #e6f1ff;\n}\n\n.tab-bar {\n  border-color: @border;\n}\n\n.tab {\n  color: @muted;\n  font-size: 0.82rem;\n  font-weight: 600;\n\n  &.active {\n    color: @primary;\n    border-bottom-color: @primary;\n  }\n}\n\n.survey-container,\n.upload-panel {\n  .surface-card();\n}\n\n.survey-container .sd-root-modern,\n.survey-panel-side .sd-root-modern,\n.form-modal .sd-root-modern {\n  --sjs-primary-backcolor: @primary;\n  --sjs-primary-backcolor-dark: @primary-hover;\n  --sjs-primary-backcolor-light: #e9f3ff;\n  --sjs-general-backcolor: @surface;\n  --sjs-general-forecolor: @text;\n  --sjs-border-default: @border;\n  --sjs-font-family: var(--font);\n  --sjs-base-unit: 6px;\n  --sd-base-padding: 5px;\n  --sd-base-vertical-padding: 8px;\n  --sd-page-vertical-padding: 8px;\n}\n\n.upload-dropzone label {\n  border-color: #b9cee3;\n  background: #f8fbff;\n\n  &:hover {\n    border-color: @primary;\n    background: #edf6ff;\n  }\n}\n\n.alert {\n  border-radius: @radius;\n  box-shadow: 0 4px 14px fade(@navy-deep, 5%);\n}\n\n.table-empty,\n.form-load-error {\n  border-color: @border;\n  background: @surface;\n  box-shadow: @shadow;\n}\n\n.form-modal-overlay {\n  background: fade(@navy-deep, 55%);\n  -webkit-backdrop-filter: blur(3px);\n  backdrop-filter: blur(3px);\n}\n\n.form-modal {\n  border: 1px solid fade(#fff, 45%);\n  box-shadow: 0 28px 70px fade(@navy-deep, 35%);\n}\n\n.loading-screen {\n  color: @muted;\n  background: @sky;\n}\n\n@media (max-width: 900px) {\n  .login-visual {\n    padding: 2rem;\n  }\n\n  .header-product,\n  .header-brand-divider {\n    display: none;\n  }\n\n  .pagination {\n    grid-template-columns: 1fr;\n    justify-items: center;\n  }\n\n  .pagination-info,\n  .pagination-controls {\n    grid-column: 1;\n  }\n\n  .pagination-controls {\n    width: 100%;\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 680px) {\n  .login-page {\n    display: block;\n  }\n\n  .login-visual {\n    min-height: 150px;\n    padding: 1.5rem;\n  }\n\n  .login-panel {\n    min-height: calc(100vh - 150px);\n    padding: 2.25rem 1.25rem 4.5rem;\n  }\n\n  .footer-need-help {\n    right: 1.25rem;\n    left: 1.25rem;\n  }\n\n  .app-header-inner {\n    min-height: 64px;\n  }\n\n  .header-logo {\n    height: 28px;\n  }\n\n  .header-client-logo {\n    height: 100%;\n    width: auto;\n  }\n\n  .header-product {\n    max-width: 7.5rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .user-label-name {\n    display: inline-block;\n    max-width: 120px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .app-nav-inner {\n    padding-inline: 0.75rem;\n  }\n\n  .nav-link {\n    padding-inline: 0.55rem;\n  }\n\n  .app-main {\n    padding: 1rem 0.75rem 2rem;\n  }\n\n  .filters-panel {\n    margin-bottom: 0.75rem;\n  }\n\n  .filters-bar {\n    margin: 0;\n    border-radius: 0;\n  }\n\n  .filter-actions {\n    width: 100%;\n    justify-content: flex-end;\n    margin-left: 0;\n  }\n\n  .table-wrap {\n    border-top: 1px solid @border;\n    border-radius: @radius-lg;\n  }\n\n  .referral-card {\n    border-color: @border;\n    box-shadow: @shadow;\n  }\n\n  .referrals-cards-sort .th-sort {\n    border-color: @border;\n  }\n\n  .detail-card {\n    padding: 1rem;\n  }\n\n  .detail-meta {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .form-modal-overlay {\n    padding: 0;\n  }\n\n  .form-modal {\n    min-height: 100vh;\n    max-height: none;\n    border-radius: 0;\n  }\n}\n\n@media (max-width: 430px) {\n  .header-actions {\n    gap: 0.35rem;\n  }\n\n  .header-brand-divider,\n  .header-product {\n    display: none;\n  }\n\n  .header-client-logo {\n    height: 100%;\n    width: auto;\n  }\n\n  .user-label {\n    padding-inline: 0.25rem;\n  }\n\n  .user-label-name {\n    max-width: 78px;\n  }\n\n  .btn-header {\n    padding-inline: 0.7rem;\n  }\n\n  .nav-tabs .nav-link.active[aria-current='page'] {\n    display: none;\n  }\n\n  .detail-meta {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-height: 720px) and (min-width: 681px) {\n  .login-panel {\n    padding-block: 1.25rem;\n  }\n\n  .login-header {\n    margin-bottom: 1.25rem;\n\n    h1 {\n      margin-top: 0.8rem;\n    }\n  }\n\n  .login-logo {\n    width: 30px;\n    height: 43px;\n  }\n\n  .login-form {\n    gap: 0.75rem;\n  }\n\n  .login-divider {\n    margin-block: 0.9rem;\n  }\n\n  .footer-need-help {\n    bottom: 0.85rem;\n  }\n}\n\n.page--new-referral .sd-root-modern .sd-title.sd-container-modern__title {\n  padding: 0.15rem 0.2rem 0.9rem !important;\n  background: transparent !important;\n  color: @text !important;\n  text-align: left;\n\n  .sd-header__text {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.45rem;\n    text-align: left;\n  }\n\n  .sd-title,\n  .sd-title .sv-string-viewer {\n    margin: 0;\n    color: @text !important;\n    font-size: 1.2rem;\n    font-weight: 700;\n    line-height: 1.25;\n    text-align: left;\n  }\n}\n\n.page--new-referral .sd-root-modern .sd-title.sd-container-modern__title .sd-description {\n  display: block;\n  max-width: 100%;\n  margin: 0.35rem 0 0;\n  padding: 0.65rem 0.85rem;\n  border-left: 3px solid #e43045;\n  border-radius: 8px;\n  background: #fff6f5;\n  color: @text !important;\n  font-size: 0.88rem;\n  font-weight: 400;\n  line-height: 1.45;\n  text-align: left;\n}\n\n.page--new-referral .sd-root-modern .sd-title.sd-container-modern__title .sd-description .sv-string-viewer {\n  color: inherit !important;\n  font-size: inherit;\n  font-weight: inherit;\n  background: transparent;\n}\n\n@import './faf.less';\n\n","/* FAF runtime step UI (google address + inline alert). */\n\n.faf-google-address {\n  width: 100%;\n}\n\n.faf-google-address-row {\n  display: flex;\n  gap: 0.5rem;\n  align-items: stretch;\n}\n\n.faf-google-address-input {\n  flex: 1 1 auto;\n  width: 100%;\n  min-height: 2.75rem;\n  padding: 0.65rem 0.85rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-sm, 6px);\n  background: var(--color-surface, #fff);\n  color: var(--color-text);\n  font: inherit;\n\n  &:focus {\n    border-color: var(--color-primary);\n    outline: 2px solid fade(#2b6cb0, 18%);\n    outline-offset: 1px;\n  }\n}\n\n.faf-google-address-map-btn {\n  flex: 0 0 auto;\n  min-width: 4.25rem;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-sm, 6px);\n  background: #f8fafc;\n  color: var(--color-text);\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n\n  &:hover {\n    border-color: var(--color-primary);\n    background: #edf6ff;\n  }\n}\n\n.faf-google-address.has-error .faf-google-address-input {\n  border-color: #dc2626;\n}\n\n.faf-inline-alert {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin: 0.35rem 0 0.65rem;\n  padding: 0.55rem 0.75rem;\n  border: 1px solid #f5c2c7;\n  border-radius: var(--radius-sm, 6px);\n  background: #fde8e8;\n  color: #842029;\n  font-size: 0.85rem;\n  line-height: 1.35;\n}\n\n.faf-inline-alert-text {\n  flex: 1 1 auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.faf-inline-alert-close {\n  flex: 0 0 auto;\n  border: none;\n  background: transparent;\n  color: inherit;\n  font-size: 1.1rem;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0 0.15rem;\n  opacity: 0.75;\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.faf-google-map-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 80;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba(15, 23, 42, 0.45);\n}\n\n.faf-google-map-dialog {\n  width: min(720px, 100%);\n  max-height: calc(100vh - 2rem);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-radius: var(--radius-md, 8px);\n  background: var(--color-surface, #fff);\n  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.28);\n}\n\n.faf-google-map-dialog-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.faf-google-map-hint {\n  font-size: 0.78rem;\n  color: var(--color-text-muted);\n}\n\n.faf-google-map-canvas {\n  width: 100%;\n  height: min(420px, 55vh);\n  background: #e2e8f0;\n}\n\n.faf-google-map-preview {\n  padding: 0.75rem 1rem;\n  border-top: 1px solid var(--color-border);\n  border-bottom: 1px solid var(--color-border);\n  font-size: 0.9rem;\n  color: var(--color-text);\n  min-height: 2.75rem;\n}\n\n.faf-google-map-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
